import { combineEpics, ofType } from "redux-observable";
import { toast } from "react-toastify";
import {
  catchError,
  concatMap,
  debounceTime,
  delay,
  distinctUntilChanged,
  endWith,
  map,
  mergeMap,
  startWith,
  switchMap,
  withLatestFrom,
} from "rxjs/operators";
import { EMPTY, from, of } from "rxjs";
import {
  fetchFormattedSchematicData,
  fetchSetDepth,
  saveMainReportDataLake,
  saveSchematicData,
  setAIEnabled,
  setCaseModifiedDate,
  setProjectDetails,
  setSchematicData,
  setSchematicEquipmentData,
  setSurfaceVoltage,
  setSchematicLoading,
  setSetDepthLoading,
} from "../../store/calculation/calculationSlice";
import * as calculationservice from "../../services/calculations/calculations.service";
import * as CalculationActions from "../../store/calculation/calculationSlice";
import {
  setFluidTabDetails,
  setRegion,
  setRegionList,
} from "../../store/calculation/calculation-input/FluidSlice";
import {
  setPumpInputCalculated,
  setPumpInputDetails,
  setPumpModelE1,
} from "../../store/calculation/calculation-output/pumpSlice";
import {
  setESPEquipmentForSensor,
  setESPEquipmentsForMotor,
  setMotorInput,
} from "../../store/calculation/calculation-output/motorSlice";
import { setProjectTabDetails } from "../../store/calculation/calculation-input/ProjectTabSlice";
import {
  BasicTDHCalculation,
  BasicWellIPRCalculation,
  Equipment,
  GasCalculationOutPut,
  GasFlowInObject,
  MotorLoadDifferentFrequencyRequest,
  onCalculatePayload,
  saveProjectPayload,
  TDHInObject,
  WellSurveyServerData,
} from "../../store/model/calculations/calculation";
import {
  fetchGasAnchorCalculation,
  setAnchorODList,
  setExistedGasHandlerEquipments,
  setExistedGasSepEquipments,
  setExistedSRGasPump1Equipments,
  setExistedSRGasPump2Equipments,
  setExistedSRGasPump3Equipments,
  setGasCalculation,
  setGasCalculation2,
  setGasCalculationOutput,
  setGasIntakeNaturalEff,
  setGasIntakeNaturalEff2,
  setGasTubingODList,
} from "../../store/calculation/calculation-output/gasCalculaionSlice";
import {
  FetchSetDepth,
  getCalculations,
  getSchematicData,
  getSurfaceVoltageValue,
  onCalculate,
} from "../../services/calculations/calculations.service";
import { setWellTabDetails } from "../../store/calculation/calculation-input/WellSlice";
import {
  setBottomEspSensor,
  setEspLength,
  setNotes,
  setTailPipeDesander,
  setWellDataInMainReportFlag,
  setWellKOPOverride,
} from "../../store/calculation/calculation-output/wellSurveySlice";
import { RootState } from "../../store/ConfigureStore";
import {
  setCasingODList,
  setCasingWeightList,
  setCatalogType,
  setCatalogType2,
  setChargePumpShowAll,
  setHiddenMotorSeries,
  setHiddenProtectorBearingType,
  setHiddenProtectorShaftType,
  setLinerODList,
  setLinerWeightList,
  setTubingDetails,
  setTubingODList,
  setTubingTypeList,
  setTubingTypeUpsetList,
  setTubingWeightList,
  setWellTrajectoryList,
} from "../../store/calculation/calculation-input/TubingSlice";
import {
  setBasicTDHCalculation,
  setBasicTDHCalculationOutput,
  setBasicWellInflowCalculation,
  setBasicWellInflowCalculation2,
  setBasicWellIPRDepletionPressure,
  setBasicWellIPRFutureProdRate,
  setShowDepletionPlotInMainReport,
  setShowIPRPlotInMainReport,
} from "../../store/calculation/calculation-output/basicCalculationSlice";
import {
  EquipmentType,
  SchematicsModel,
  SREquipmentsDto,
} from "../../store/model/calculations/schematics";
import {
  mappedMotorLockEquipments,
  mappedExistedEquipments,
  mapToSREquipmentsDto,
  transformObjectToDropdownOptions,
  getMainReportDataFromUtility,
  formatDateDDMMYYYY,
} from "../../utilities/commonUtilities";
import {
  setSelectedLowerEquipment,
  setSelectedUpperEquipment,
} from "../../store/calculation/calculation-output/protectorSlice";
import {
  setESPEquipmentsForBOH,
  setESPEquipmentsForPumps,
} from "../../store/calculation/calculation-output/pumpSlice";
import {
  setSelectedWellEquipment,
  setSelectedWellLockEquipment,
} from "../../store/calculation/calculation-output/cableSlice";
import {
  setESPEquipmentsForAbove,
  setESPEquipmentsForBelow,
} from "../../store/calculation/calculation-output/schematicSlice";
import {
  setHfFilterSelection,
  setHfInstallationType,
  setSelectedTransformer,
  setEspEquipments,
} from "../../store/calculation/calculation-output/surfaceEquipmentSlice";
import {
  setControllerList,
  setOtherDetails,
  setSupplyPowerList,
} from "../../store/calculation/calculation-input/OthersSlice";
import {
  setCase1SystemTDH,
  setCase2SystemTDH,
  setCase3SystemTDH,
  setComparisonData1,
  setComparisonData2,
  setComparisonData3,
  setComparisonInput1,
  setComparisonInput2,
  setComparisonInput3,
  setPersistedCase1,
  setPersistedCase2,
  setPersistedCase3,
} from "../../store/comparison/comparisonSlice";


const fetchProjectDetailsEpic = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("calculations/getProjectDetails"),
    withLatestFrom(
      state$.pipe(
        map((state: RootState) => state?.myProjects?.selectedProject)
      ),
      state$.pipe(map((state: RootState) => state?.createProject?.template))
    ),
    concatMap(([actionData, selectedProject, selectedTemplate]) => {
      return from(
        getCalculations(
          actionData
            ? {
              id: actionData?.payload?.id,
              templateid: actionData?.payload?.templateid,
            }
            : { id: selectedProject?.projectID, templateid: selectedTemplate }
        )
      ).pipe(
        map((result) => {
          const anchorODList =
            result?.item2.espBasicCalculation?.basicGasCalculation
              ?.anchorODList;
          const updatedAnchorODList = anchorODList
            ? Object.entries(anchorODList).map(([name, id]) => ({
              id: String(id),
              name,
            }))
            : [];
          const pumpInputCalculation = {
            flwCrrctnForPump:
              result?.item1?.pumpInput?.pumpFlowCorrection?.toString(),
            hdCrrctnForPump:
              result?.item1?.pumpInput?.pumpHeadCorrection?.toString(),
            pWRCrrctnForPump:
              result?.item1?.pumpInput?.pumpPowerCorrection?.toString(),
            hPOPPump: "",
            minNoOfStages: "",
            ftLftPerStage: "",
            pmpFinalTDH: "",
            hPOPPump60Hz: "",
            efficiency: "",
          };

          // var compositepumpInput = new CompPumpInputCalculated();
          var output = {
            result,
            updatedAnchorODList,
            pumpInputCalculation,
          };
          return output;
        }),
        mergeMap((output) => {
          var gasOutput = {
            GKX_FlowCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.gkxFlowCorrection,
            GKX_HeadCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.gkxHeadCorrection,
            GKX_PowerCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.gkxPowerCorrection,
            CP1_FlowCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.cP1FlowCorrection,
            CP1_HeadCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.cP1HeadCorrection,
            CP1_PowerCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.cP1PowerCorrection,
            CP2_FlowCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.cP2FlowCorrection,
            CP2_HeadCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.cP2HeadCorrection,
            CP2_PowerCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.cP2PowerCorrection,
            CP3_FlowCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.cP3FlowCorrection,
            CP3_HeadCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.cP3HeadCorrection,
            CP3_PowerCorrection:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.cP3PowerCorrection,
            Intake_NaturalSeperatorEff:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.gasIntakeNaturalSeparatorEfficiency,
            ChargePumpShowAll:
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.chargePumpShowAll,
          } as GasCalculationOutPut;
          return [
            setCaseModifiedDate(formatDateDDMMYYYY(output?.result?.item1?.caseModifiedDate)),
            setAIEnabled(output?.result?.item1?.aiEnabled),
            setComparisonInput1(output?.result?.item1.comparisonCaseId1),
            setComparisonInput2(output?.result?.item1.comparisonCaseId2),
            setComparisonInput3(output?.result?.item1.comparisonCaseId3),
            setPersistedCase1(output?.result?.item1.comparisonCaseId1),
            setPersistedCase2(output?.result?.item1.comparisonCaseId2),
            setPersistedCase3(output?.result?.item1.comparisonCaseId3),
            setProjectDetails(output?.result?.item1),
            setProjectTabDetails(output?.result?.item1?.tab4Input),
            setTubingDetails(output?.result?.item1?.tab1Input),
            setTubingTypeUpsetList(
              output?.result?.item1?.tab1Input?.tubingTypeUpsetList
            ),
            setTubingTypeList(output?.result?.item1?.tab1Input?.tubingTypeList),
            setWellTrajectoryList(
              output?.result?.item1?.tab1Input?.wellTrajectoryList
            ),
            setWellTabDetails(output?.result?.item1?.tab2Input),
            setFluidTabDetails(output?.result?.item1?.tab3Input),
            setOtherDetails(output?.result?.item1?.tab5Input),
            setSupplyPowerList(
              output?.result?.item1?.tab5Input?.unitSuplPwrList
            ),
            setControllerList(output?.result?.item1?.tab5Input?.unitContrlList),
            setHiddenMotorSeries(
              output?.result?.item1?.tab1Input?.hiddenMotrSers === "-1"
                ? "0"
                : output?.result?.item1?.tab1Input?.hiddenMotrSers
            ),
            setRegion(output?.result?.item1?.region?.selectedId),
            setRegionList(output?.result?.item1?.region?.regionList),
            setGasCalculationOutput(gasOutput),
            setGasIntakeNaturalEff2(
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.gasIntakeNaturalSeparatorEfficiency
            ),
            setGasCalculation(
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
            ),
            setAnchorODList(output?.updatedAnchorODList),
            setGasTubingODList(
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.anchorTubingODList
            ),
            setChargePumpShowAll(
              output?.result?.item2?.espBasicCalculation?.basicGasCalculation
                ?.chargePumpShowAll
            ),
            setBasicWellInflowCalculation(
              output?.result?.item2?.espBasicCalculation
                ?.basicWellInflowCalculation
            ),
            setBasicTDHCalculation(
              output?.result?.item2?.espBasicCalculation?.basicTDHCalculation
            ),
            setBasicWellIPRDepletionPressure(
              output?.result?.item2?.espBasicCalculation
                ?.basicWellIPRCalculation?.depletionPressure
            ),
            setBasicWellIPRFutureProdRate(
              output?.result?.item2?.espBasicCalculation
                ?.basicWellIPRCalculation?.futureProductionRate
            ),
            setShowIPRPlotInMainReport(
              output?.result?.item2?.espBasicCalculation
                ?.basicWellIPRCalculation?.showIPRPlotInMainReport
            ),
            setShowDepletionPlotInMainReport(
              output?.result?.item2?.espBasicCalculation
                ?.basicWellIPRCalculation?.showDepletionPlotInMainReport
            ),
            setPumpInputDetails(output?.result?.item1?.pumpInput),
            setMotorInput({
              ...output?.result?.item1?.motorInput,
              motorLoad:
                output?.result?.item1?.motorInput?.motorLoad > 0
                  ? output?.result?.item1.motorInput.motorLoad
                  : 100,
            }),
            setWellDataInMainReportFlag(
              output?.result?.item1?.wellSurveyESPAssembly
                ?.showWellDataInMainReport
            ),
            setNotes(output?.result?.item1?.wellSurveyESPAssembly?.notes),
            setEspLength(
              output?.result?.item1?.wellSurveyESPAssembly?.espLength
            ),
            setBottomEspSensor(
              output?.result?.item1?.wellSurveyESPAssembly?.bottomOfESPSensor
            ),
            setWellKOPOverride(
              output?.result?.item1?.wellSurveyESPAssembly?.kOP
            ),
            setTailPipeDesander(
              output?.result?.item1?.wellSurveyESPAssembly?.tailPipeDesander
            ),
            setPumpInputCalculated(output?.pumpInputCalculation),
            setPumpModelE1(output?.result?.item1?.pumpModelE1),
            setCasingODList(output?.result?.item1?.tab1Input?.casingODList),
            setCasingWeightList(
              output?.result?.item1?.tab1Input?.casingWeightList
            ),
            setLinerODList(output?.result?.item1?.tab1Input?.linerODList),
            setHfInstallationType({
              installationType:
                output?.result?.item1?.pumpInput?.installationType,
              estimatedCurrentAmps:
                output?.result?.item1?.pumpInput?.estimatedCurrentAmps,
            }),
            setHfFilterSelection(
              output?.result?.item1?.pumpInput?.filterSelection
            ),
            setLinerWeightList(
              output?.result?.item1?.tab1Input?.linerWeightList
            ),
            setTubingODList(output?.result?.item1?.tab1Input?.tubingODList),
            setTubingWeightList(
              output?.result?.item1?.tab1Input?.tubingWeightList
            ),
          ];
        }),
        catchError((error) => {
          return of({
            type: "calculations/fetchProjectDetailsError",
            payload: error.message,
          });
        })
      );
    })
  );
};

const calculationsTemplate = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("calculations/fetchTemplateCalculations"),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state?.createProject?.template)),
      state$.pipe(map((state: RootState) => state?.createProject))
    ),
    switchMap(([actionData, templateId, projectdata]) => {
      return from(
        getCalculations({
          id: "",
          templateid: actionData?.payload || templateId,
        })
      ).pipe(
        mergeMap((data) => {
          if (data) {
            return [
              setProjectDetails(data?.item1),
              setTubingDetails(data?.item1?.tab1Input),
              setTubingTypeUpsetList(
                data?.item1?.tab1Input?.tubingTypeUpsetList
              ),
              setTubingTypeList(data?.item1?.tab1Input?.tubingTypeList),
              setWellTrajectoryList(data?.item1?.tab1Input?.wellTrajectoryList),
              setCatalogType2(2),
              setHiddenProtectorBearingType(1),
              setHiddenProtectorShaftType(1),
              setWellTabDetails(data?.item1?.tab2Input),
              setFluidTabDetails(data?.item1?.tab3Input),
              setProjectTabDetails({
                ...projectdata,
                wellName:
                  typeof projectdata?.well === "string"
                    ? projectdata?.well
                    : projectdata?.wellList.find(
                      (x: any) => x?.value === projectdata?.well
                    )?.label,
                wellApiNo: projectdata?.wellApiNo,
                countryList: projectdata?.countryList,
                caseName: projectdata?.caseName,
                companyName:
                  typeof projectdata?.customer === "string"
                    ? projectdata?.customer
                    : projectdata?.customerList.find(
                      (x: any) => x?.value === projectdata.customer
                    )?.label,
              }),
              setOtherDetails(data?.item1?.tab5Input),
              setSupplyPowerList(data?.item1?.tab5Input?.unitSuplPwrList),
              setControllerList(data?.item1?.tab5Input?.unitContrlList),
              setCasingODList(data?.item1?.tab1Input?.casingODList),
              setCasingWeightList(data?.item1?.tab1Input?.casingWeightList),
              setLinerODList(data?.item1?.tab1Input?.linerODList),
              setLinerWeightList(data?.item1?.tab1Input?.linerWeightList),
              setTubingODList(data?.item1?.tab1Input?.tubingODList),
              setTubingWeightList(data?.item1?.tab1Input?.tubingWeightList),
              setAnchorODList(
                transformObjectToDropdownOptions(
                  data?.item2?.espBasicCalculation?.basicGasCalculation
                    ?.anchorODList
                )
              ),
              setBasicWellInflowCalculation2(
                data?.item2?.espBasicCalculation?.basicWellInflowCalculation
              ),
              setBasicTDHCalculation(
                data?.item2?.espBasicCalculation?.basicTDHCalculation
              ),
              setPumpInputDetails(data?.item1?.pumpInput),
              setPumpModelE1(data?.item1?.pumpModelE1),
              setGasCalculation2(
                data?.item2?.espBasicCalculation?.basicGasCalculation
              ),
              setRegion(data?.item1?.region?.selectedId),
              setRegionList(data?.item1?.region?.regionList),
            ];
          } else {
            return of({ type: "" });
          }
        }),
        catchError((error) => {
          return of(console.error(error));
        })
      );
    })
  );
};

const fetchOnCalculate = (action$: any, state$: any) => {
  return action$.pipe(
    ofType(
      "gasCalculation/setGasCalculation",
      "tubing/setHiddenGasNatrAutoEff",
      "gasCalculation/gasCalculationStart",
      "gasCalculation/setGasIntakeNaturalEff"
    ),
    withLatestFrom(
      state$.pipe(
        map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)
      ),
      state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
      state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
      state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
      state$.pipe(
        map((state: RootState) => state?.myProjects?.selectedProject)
      ),
      state$.pipe(
        map(
          (state: RootState) =>
            state?.gasCalculations?.GasCalculationOutPut
              ?.Intake_NaturalSeperatorEff
        )
      ),
      state$.pipe(map((state: RootState) => state?.fluid?.region)),
      state$.pipe(map((state: RootState) => state?.fluid?.regionList)),
      state$.pipe(map((state: RootState) => state?.fluid?.selectedRegion))
    ),
    concatMap(
      ([
        actionData,
        basicGasCalculation,
        tab1Input,
        tab2Input,
        tab3Input,
        projectId,
        intakeNaturalSepEff,
        region,
        regionList,
        selectedRegion,
      ]) => {
        const selectRegion = regionList?.find((x: any) => x?.id === region);
        var tDHInObject: TDHInObject = {
          spGrWater: tab3Input?.spGrWater,
          tubingPressure: tab2Input?.tubingPressure,
          tubingID: +tab1Input?.tubingID,
          pumpSetting: tab2Input?.pumpSetting,
          productionRate: tab2Input?.productionRate,
          tVD: tab2Input?.tvd,
          fLOP: tab2Input?.flop,
          combinedSpGr: tab3Input?.combinedSpGr ?? 0,
          casingPressure: tab2Input?.casingPressure ?? 0,
          tubingAge: tab1Input?.tubingType,
          casingPressureUnit: +tab2Input?.unitCasingPressureListVal,
          fLOPUnit: +tab2Input?.unitFLOPListVal,
          productionRateUnit: +tab2Input?.unitProductionRateListVal,
          pumpSettingUnit: +tab2Input?.unitPumpSettingListVal,
          tubingPressureUnit: +tab2Input?.unitTubingPressureListVal,
          unitSystem: tab1Input?.unitSys,
          casingOD: tab1Input?.casingOD,
          tubingIDUnit: +tab1Input?.unitTubingIDListVal,
          tVDUnit: +tab2Input?.unitTVDListVal,
          finalPIP: 0,
        };

        var BOPD = tab3Input?.bopd;
        var spGrGas = tab3Input?.spGrGas;
        var GOR = +tab3Input?.gor;
        var gasAvail = tab3Input?.gasAvailblty;
        var GasComprs = tab3Input?.gasCompressibility;
        var bubbPres = tab3Input?.bubblePoint;
        var GasProd = tab3Input?.gasProduction ?? 0;
        var intake_NaturalSepEff = Number(intakeNaturalSepEff) ?? 0;

        var gasDesign = "";

        if (gasAvail === "0") {
          GOR = 0;
          GasComprs = 0;
          gasDesign = "0";
          spGrGas = 0;
          bubbPres = 0;
          GasProd = 0;
        }
        if (gasAvail === "1") {
          gasDesign = basicGasCalculation?.gasDesign;
        }

        var gasFlowInObject: GasFlowInObject = {
          casingID: +tab1Input?.casingID,
          tubingOD: tab1Input?.tubingOD,
          productionRate: tab2Input?.productionRate,
          spGrWater: tab3Input?.spGrWater,
          waterCut: tab3Input?.waterCut,
          combinedSpGr: +tab3Input?.combinedSpGr || 0,
          liquidPhaseSpGr: +tab3Input?.liquidPhaseCombinedSpGr || 0,
          bWPD: tab3Input?.bwpd,
          oilAPI: tab3Input?.oilAPI,
          spGrOil: tab3Input?.spGrOil,
          bOPD: tab3Input?.bopd,
          spGrGas: spGrGas,
          gOR: GOR,
          bottomHoleTemp: tab3Input?.bottomHoleTemp,
          gasDesign: +gasDesign,
          anchorOD: +basicGasCalculation?.anchorOD || 0,
          anchorID: +basicGasCalculation?.anchorID || 0,
          anchorTubingOD: +basicGasCalculation?.tubingOD || 0,
          bOPDUnit: +tab3Input?.unitBOPDListVal || 0,
          bWPDUnit: +tab3Input?.unitBWPDListVal || 0,
          bottomHoleTempUnit: +tab3Input?.unitBottomHoleTempListVal || 0,
          gORUnit: +tab3Input?.unitGORListVal || 0,
          productionRateUnit: +tab2Input?.unitProductionRateListVal || 0,
          unitSystem: tab1Input?.unitSys,
          casingPressure: tab2Input?.casingPressure || 0,
          casingPressureUnit:
            tab2Input?.unitCasingPressureListVal?.toString() == undefined
              ? 0
              : +tab2Input?.unitCasingPressureListVal,
          fLOP: tab2Input?.flop,
          gasCompressibility: GasComprs,
          isNatural: Boolean(tab1Input?.hiddenGasNatrEffAuto?.toString()),
          perforation: tab2Input?.perforation,
          perforationUnit: +tab2Input?.unitPerforationListVal || 0,
          bubblePointPressure: bubbPres,
          bubblePointPressureUnit: tab3Input?.unitBubblePointListVal || 0,
          pumpSetting: tab2Input?.pumpSetting,
          pumpSettingUnit: +tab2Input?.unitPumpSettingListVal || 0,
          isGas: Boolean(tab3Input?.gasAvailblty),
          gasProduction: GasProd,
          gasProductionUnit: +tab3Input?.unitGasProductionListVal || 0,
          casingIDUnit: +tab1Input?.unitCasingIDListVal || 0,
          fLOPUnit: +tab2Input?.unitFLOPListVal || 0,
          inflowType: +(tab2Input?.inflowTypeLstVal || 0),
          staticBHP: tab2Input?.sbhpForPressre,
          staticFluidLevel: tab2Input?.staticFluidLvl,
          projectId: projectId?.projectID ?? "",
          intakeNaturalSeparatorEff: intake_NaturalSepEff,
          chargePumpShowAll: tab1Input?.chargePumpShowAll ?? false,
          regionName: selectRegion?.name ?? selectedRegion,
        };

        if (gasFlowInObject.inflowType === 0) {
          gasFlowInObject.staticBHP = +tab2Input?.reservoirPressure;
          gasFlowInObject.staticFluidLevel = 0;
        } else if (gasFlowInObject.inflowType === 2) {
          gasFlowInObject.staticFluidLevel = +tab2Input?.staticFluidLvlForHd;
        }

        var chrgePmpArray: any = [BOPD];
        const catalogFilter = +tab1Input?.catalogType;
        const payload = {
          tdhValues: tDHInObject,
          gasCalcValues: gasFlowInObject,
          chrgePmpVals: chrgePmpArray,
          catalogFilter: catalogFilter,
        } as onCalculatePayload;

        return from(onCalculate(payload)).pipe(
          mergeMap((data) => {
            var gasOutput: GasCalculationOutPut = {
              Intake_NaturalSeperatorEff: data?.[9],
              Intake_VolumeOfGas: data?.[10],
              Intake_FreeGas: data?.[13],
              Intake_GVF: data?.[14],
              Intake_GOR: data?.[15],
              Intake_GLR: data?.[24],
              Intake_Pressure: data?.[33],
              Intake_LiquidPhaseDensity: data?.[27],
              Intake_Rs: data?.[28],
              Intake_Bg: data?.[29],
              Intake_Bo: data?.[30],
              Intake_VolumeOfOil: data?.[31],
              Intake_VolumeOfWater: data?.[32],
            };
            var tdhOutput: BasicTDHCalculation = {
              tubingHead: data?.[4]?.toString(),
              pipNew: data?.[33]?.toString(),
              pip: data?.[8]?.toString(),
              tdh: data?.[5]?.toString(),
              productionLevel: data?.[7]?.toString(),
              frictionLoss: data?.[6]?.toString(),
            };
            var wellIPR: BasicWellIPRCalculation = {
              depletionPressure: data?.[38],
              futureProductionRate: data?.[39],
            };
            var result = {
              gasOutput: gasOutput,
              tdhOutput: tdhOutput,
              wellIPR,
            };
            return [
              setGasCalculationOutput(result?.gasOutput),
              setBasicTDHCalculationOutput(result?.tdhOutput),
              setBasicWellIPRDepletionPressure(
                result?.wellIPR?.depletionPressure
              ),
              setBasicWellIPRFutureProdRate(
                result.wellIPR.futureProductionRate
              ),
              fetchGasAnchorCalculation(),
            ];
          }),
          catchError((error) => of(CalculationActions.calculateFailure(error))),
          startWith(CalculationActions.setLoading(true)),
          endWith(CalculationActions.setLoading(false))
        );
      }
    )
  );
};

const convertSchematicsDataToEquipment = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("calculations/fetchFormattedSchematicData"),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state?.calculations?.schematicData)),
      state$.pipe(map((state: RootState) => state?.calculations?.intakeMD)),
    ),
    map(([actionData, schematicData, intakeMD]) => {
      const gasSepFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRGasSeparators
      );
      const gasHandlerfilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRGasHandlers
      );
      const CP1Filter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRChargePump1
      );
      const CP2Filter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRChargePump2
      );
      const CP3Filter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRChargePump3
      );
      const pumpsFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRPumps
      );
      const protectorFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRProtectors
      );
      const bohFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRBOH
      );
      const cableFilterData = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRCables
      );
      const motorLockFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRMLE
      );
      const motorFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRMotors
      );
      const motorSensorFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRSensor
      );
      const accAboveESPFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRAccAboveESP
      );
      const accBelowESPFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRAccBelowESP
      );
      const surfaceFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRTransformers
      );
      const ESPEquipmentsFilter = schematicData?.equipmentsList?.filter(
        (x: any) => x?.equipmentType === EquipmentType?.SRVSDs
      );

      const protectors = schematicData?.equipmentsList?.filter(
        (p: any) => p?.equipmentType === EquipmentType?.SRProtectors
      );

      let newcablelength = intakeMD ? intakeMD : schematicData?.setDepth || 0;
      if (protectors?.length === 1 && protectors?.[0]?.equipments === "0" && protectors?.[0] && protectors?.[0]?.setDepth) {
        newcablelength = protectors?.[0]?.setDepth;
      } else if (protectors?.length === 2 && protectors?.[0] && protectors?.[0]?.setDepth) {
        newcablelength = protectors?.[0]?.setDepth;
      }

      let cableFilter: Equipment[] = cableFilterData;
      if (cableFilterData?.[0]) {
        cableFilter = [
          {
            ...cableFilterData[0],
            totalLength: newcablelength,
            length: newcablelength,
          },
        ];
      }

      var result = {
        gasSepFilter,
        gasHandlerfilter,
        CP1Filter,
        CP2Filter,
        CP3Filter,
        pumpsFilter,
        protectorFilter,
        bohFilter,
        cableFilter,
        motorLockFilter,
        motorFilter,
        motorSensorFilter,
        accAboveESPFilter,
        accBelowESPFilter,
        surfaceFilter,
        ESPEquipmentsFilter,
      };
      return result;
    }),
    mergeMap((result: any) => {
      return [
        setExistedGasSepEquipments(
          result?.gasSepFilter?.length > 0
            ? mappedExistedEquipments(result?.gasSepFilter)
            : []
        ),
        setExistedGasHandlerEquipments(
          result?.gasHandlerfilter?.length > 0
            ? mappedExistedEquipments(result?.gasHandlerfilter)
            : []
        ),
        setExistedSRGasPump1Equipments(
          result?.CP1Filter?.length > 0
            ? mappedExistedEquipments(result?.CP1Filter)
            : []
        ),
        setExistedSRGasPump2Equipments(
          result?.CP2Filter?.length > 0
            ? mappedExistedEquipments(result?.CP2Filter)
            : []
        ),
        setExistedSRGasPump3Equipments(
          result?.CP3Filter?.length > 0
            ? mappedExistedEquipments(result?.CP3Filter)
            : []
        ),
        setSelectedLowerEquipment(
          result?.protectorFilter?.length === 1 &&
            result?.protectorFilter[0].equipments === "0"
            ? mappedExistedEquipments(result?.protectorFilter)
            : result?.protectorFilter?.length === 2
              ? mappedExistedEquipments([result?.protectorFilter[0]])
              : []
        ),
        setSelectedUpperEquipment(
          result?.protectorFilter?.length === 1 &&
            result?.protectorFilter[0].equipments === "1"
            ? mappedExistedEquipments(result?.protectorFilter)
            : result?.protectorFilter?.length === 2
              ? mappedExistedEquipments([result?.protectorFilter[1]])
              : []
        ),
        setESPEquipmentsForBOH(
          result?.bohFilter?.length > 0
            ? mappedExistedEquipments(result?.bohFilter)
            : []
        ),
        setESPEquipmentsForPumps(
          result?.pumpsFilter?.length > 0
            ? mappedExistedEquipments(result?.pumpsFilter)
            : []
        ),
        setSelectedWellEquipment(
          result?.cableFilter?.length > 0
            ? mappedExistedEquipments(result?.cableFilter)
            : [{}]
        ),
        setSelectedWellLockEquipment(
          result?.motorLockFilter?.length > 0
            ? mappedMotorLockEquipments(result?.motorLockFilter)
            : [{}]
        ),
        setESPEquipmentsForMotor(
          result?.motorFilter?.length > 0
            ? mappedExistedEquipments(result?.motorFilter)
            : []
        ),
        setESPEquipmentForSensor(
          result?.motorSensorFilter?.length > 0
            ? mappedExistedEquipments(result?.motorSensorFilter)
            : []
        ),
        setESPEquipmentsForAbove(
          result?.accAboveESPFilter?.length > 0
            ? mappedExistedEquipments(result?.accAboveESPFilter)
            : []
        ),
        setESPEquipmentsForBelow(
          result?.accBelowESPFilter?.length > 0
            ? mappedExistedEquipments(result?.accBelowESPFilter)
            : []
        ),
        setSelectedTransformer(
          result?.surfaceFilter?.length > 0
            ? mappedExistedEquipments(result?.surfaceFilter)
            : []
        ),
        setEspEquipments(
          result?.ESPEquipmentsFilter?.length > 0
            ? mappedExistedEquipments(result?.ESPEquipmentsFilter)
            : []
        ),
      ];
    })
  );
};

const fetchSchematicData = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("calculations/fetchSchematicData"),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state?.myProjects?.selectedProject))
    ),
    switchMap(([actionData, selectedProject]) => {
      const projectId: string = actionData?.payload
        ? actionData?.payload
        : selectedProject?.projectID || selectedProject?.caseID;
      return from(getSchematicData(projectId)).pipe(
        mergeMap((data) => {
          return [setSchematicData(data), fetchFormattedSchematicData()];
        }),
        catchError((error) =>
          of(
            CalculationActions.setError(
              error?.message || "Failed to fetch schematics"
            )
          )
        ),
        startWith(setSchematicLoading(true)),
        endWith(setSchematicLoading(false))
      );
    })
  );
};

const SetSchematicEquipmentData = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("calculations/fetchUpdatedSchematicEquipmentData"),
    withLatestFrom(
      state$.pipe(
        map((state: RootState) => state?.myProjects?.selectedProject)
      ),
      state$.pipe(
        map(
          (state: RootState) => state?.gasCalculations?.existedGasSepEquipments
        )
      ),
      state$.pipe(
        map(
          (state: RootState) =>
            state?.gasCalculations?.existedGasHandlerEquipments
        )
      ),
      state$.pipe(
        map(
          (state: RootState) =>
            state?.gasCalculations?.existedSRGasPump1Equipments
        )
      ),
      state$.pipe(
        map(
          (state: RootState) =>
            state?.gasCalculations?.existedSRGasPump2Equipments
        )
      ),
      state$.pipe(
        map(
          (state: RootState) =>
            state?.gasCalculations?.existedSRGasPump3Equipments
        )
      ),
      state$.pipe(map((state: RootState) => state?.pump?.ESPEquipments)),
      state$.pipe(map((state: RootState) => state?.pump?.ESPEquipmentsBOH)),
      state$.pipe(map((state: RootState) => state?.motor?.ESPEquipments)),
      state$.pipe(
        map((state: RootState) => state?.motor?.ESPEquipmentsForSensor)
      ),
      state$.pipe(
        map((state: RootState) => state?.schematic?.ESPEquipmentsForAbove)
      ),
      state$.pipe(
        map((state: RootState) => state?.schematic?.ESPEquipmentsForBelow)
      ),
      state$.pipe(
        map((state: RootState) => state?.protector?.selectedLowerEquipment)
      ),
      state$.pipe(
        map((state: RootState) => state?.protector?.selectedUpperEquipment)
      ),
      state$.pipe(
        map((state: RootState) => state?.cable?.selectedWellLockEquipment)
      ),
      state$.pipe(
        map((state: RootState) => state?.cable?.selectedWellEquipment)
      ),
      state$.pipe(
        map((state: RootState) => state?.surfaceEquipment?.ESPEquipments)
      ),
      state$.pipe(
        map((state: RootState) => state?.surfaceEquipment?.SelectedTransformer)
      ),
      state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input))
    ),
    map(
      ([
        actionData,
        project,
        gasSepEquipments,
        gasHandlers,
        pump1,
        pump2,
        pump3,
        pumpEquipments,
        bohEquipment,
        motorEquipments,
        sensorEquipments,
        aboveEquipments,
        belowEquipments,
        lowerProtector,
        upperProtector,
        mleEquipments,
        cableEquipments,
        surfaceEquipments,
        transformerEquipments,
        tab2Input,
      ]) => {
        const { projectID } = project ?? {};
        const combinedEquipments: SREquipmentsDto[] = [
          ...gasSepEquipments.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRGasSeparators,
              index
            )
          ),
          ...gasHandlers.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRGasHandlers,
              index
            )
          ),
          ...pump1.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRChargePump1,
              index
            )
          ),
          ...pump2.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRChargePump2,
              index
            )
          ),
          ...pump3.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRChargePump3,
              index
            )
          ),
          ...pumpEquipments.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRPumps,
              index
            )
          ),
          ...bohEquipment?.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRBOH,
              index
            )
          ),
          ...motorEquipments.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRMotors,
              index
            )
          ),
          ...sensorEquipments.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRSensor,
              index
            )
          ),
          ...aboveEquipments.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRAccAboveESP,
              index
            )
          ),
          ...belowEquipments.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRAccBelowESP,
              index
            )
          ),
          ...lowerProtector.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRProtectors,
              index
            )
          ),
          ...upperProtector.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRProtectors,
              index,
              true
            )
          ),
          ...mleEquipments.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRMLE,
              index
            )
          ),
          ...cableEquipments.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRCables,
              index
            )
          ),
          ...surfaceEquipments.map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRVSDs,
              index
            )
          ),
          ...[transformerEquipments].map((equipment: any, index: any) =>
            mapToSREquipmentsDto(
              equipment,
              projectID,
              EquipmentType.SRTransformers,
              index
            )
          ),
        ];
        return {
          combinedEquipments,
          tab2Input,
        };
      }
    ),
    mergeMap((combinedEquipments: any) => {
      const fetchSetDepthAction = fetchSetDepth();
      return [
        CalculationActions.setSchematicMiscSetDepthValue(
          combinedEquipments?.tab2Input?.pumpSetting
        ),
        setSchematicEquipmentData(combinedEquipments?.combinedEquipments),
        fetchSetDepthAction,
      ];
    })
  );
};

const fetchCalculatedSetDepth = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("calculations/fetchSetDepth"),
    debounceTime(300),
    delay(50),
    withLatestFrom(
      state$.pipe(
        map((state: RootState) => state?.calculations?.schematicData)
      ),
      state$.pipe(map((state: RootState) => state?.createProject?.template)),
      state$.pipe(map((state: RootState) => state?.myProjects?.globalTemplate)),
      state$.pipe(
        map((state: RootState) => state?.wellInput?.tab2Input?.pumpSetting)
      ),
      state$.pipe(map((state: RootState) => state?.calculations?.projectDetails)),
    ),
    distinctUntilChanged((prev: any, curr: any) => {
      if (!prev) {
        return false;
      }
      
      const prevAction = prev[0];
      const currAction = curr[0];
      if (prevAction !== currAction) {
        return false;
      }
      
      const prevSetDepth = prev[4] ?? prev[5]?.tab2Input?.pumpSetting ?? prev[1]?.miscellaneous?.setDepthValue;
      const currSetDepth = curr[4] ?? curr[5]?.tab2Input?.pumpSetting ?? curr[1]?.miscellaneous?.setDepthValue;
      const prevEquipmentsLength = prev[1]?.equipmentsList?.length ?? 0;
      const currEquipmentsLength = curr[1]?.equipmentsList?.length ?? 0;
      const prevEquipmentsHash = prev[1]?.equipmentsList?.map((e: any) => e?.equipmentId || e?.id).join(',') || '';
      const currEquipmentsHash = curr[1]?.equipmentsList?.map((e: any) => e?.equipmentId || e?.id).join(',') || '';
      const isEqual = prevSetDepth === currSetDepth && 
             prevEquipmentsLength === currEquipmentsLength && 
             prevEquipmentsHash === currEquipmentsHash;
      
      return isEqual; // true means equal (filter out), false means different (allow through)
    }),
    switchMap(
      ([
        actionData,
        schematicData,
        templateId,
        globalTemplateList,
        setDepth,
        projectDetails
      ]) => {
        const templateName = globalTemplateList?.find(
          (t: any) => t?.templateID === templateId
        )?.templateName;
        const newSchematicData = {
          ...schematicData,
          miscellaneous: schematicData?.miscellaneous ? { ...schematicData.miscellaneous } : {},
          equipmentsList: [...(schematicData?.equipmentsList || [])],
        };

        newSchematicData.unitSystem =
          templateName === "Imperial" ||
            templateName === null ||
            templateName === undefined
            ? 0
            : 1;

        if (
          !newSchematicData?.projectId ||
          newSchematicData?.projectId === "" ||
          newSchematicData?.projectId === null
        ) {
          newSchematicData.projectId = "00000000-0000-0000-0000-000000000000";
        }

        if (!newSchematicData.miscellaneous) {
          newSchematicData.miscellaneous = {};
        }

        if (
          !newSchematicData?.miscellaneous?.projectId ||
          newSchematicData?.miscellaneous?.projectId === "" ||
          newSchematicData?.miscellaneous?.projectId === null
        ) {
          newSchematicData.miscellaneous.projectId =
            "00000000-0000-0000-0000-000000000000";
        }

        if (!newSchematicData?.equipmentsList) {
          newSchematicData.equipmentsList = [];
        } else {
          newSchematicData.equipmentsList = newSchematicData.equipmentsList.map(
            (equipment: any) => {
              if (equipment.projectId === "" || equipment.projectId === null) {
                return {
                  ...equipment,
                  projectId: "00000000-0000-0000-0000-000000000000",
                };
              }
              return equipment;
            }
          );
        }

        const latestSetDepth = setDepth ?? projectDetails?.tab2Input?.pumpSetting ?? schematicData?.miscellaneous?.setDepthValue;
        newSchematicData.miscellaneous.setDepthValue = latestSetDepth;

        if (latestSetDepth === null || latestSetDepth === undefined || isNaN(Number(latestSetDepth))) {
          return of(setSetDepthLoading(false));
        }

        return from(FetchSetDepth(newSchematicData)).pipe(
          startWith(setSetDepthLoading(true)),
          mergeMap((response: any) => {
            if (response?.type === "calculations/setSetDepthLoading") {
              return [response];
            }
            if (response?.data) {
              return [
                setSchematicData(response?.data),
                fetchFormattedSchematicData(),
                setSetDepthLoading(false),
              ];
            }
            return [setSetDepthLoading(false)];
          }),
          catchError((error) => {
            return of(
              CalculationActions.setError(
                error?.message || "Failed to fetch set depth"
              ),
              setSetDepthLoading(false)
            );
          })
        );
      }
    )
  );
};

const calculateSurfaceVoltage = (action$: any, state$: any) => {
  return action$.pipe(
    ofType(
      "calculations/fetchSchematicData",
      "cable/setCableTotalVoltageLoss",
      "motor/setESPEquipmentsForMotor"
    ),
    withLatestFrom(
      state$.pipe(
        map((state: RootState) => state?.calculations?.schematicData)
      ),
      state$.pipe(
        map((state: RootState) => state?.cable?.cableTotalVoltageLoss)
      ),
      state$.pipe(map((state: RootState) => state?.motor?.ESPEquipments)),
      state$.pipe(map((state: RootState) => state?.motor?.Equipments))
    ),
    switchMap(
      ([
        actionData,
        schematicData,
        TotalVoltageDropMaxLoad,
        selectedSchematicMotors,
        schematicMotorList,
      ]) => {
        var motorNPVolts: number = 0;
        selectedSchematicMotors.forEach((motor: any) => {
          var d = schematicMotorList.filter((x: any) => x.id == motor.id);
          motorNPVolts = motorNPVolts + d[0]?.voltage;
        });
        const newSchematicData = {
          ...schematicData,
          miscellaneous: { ...schematicData?.miscellaneous },
          equipmentsList: [...(schematicData?.equipmentsList || [])],
        };
        var maximumFrequency: number;
        maximumFrequency = newSchematicData.miscellaneous.maxFrequency || 0;

        return from(
          getSurfaceVoltageValue(
            maximumFrequency,
            Number(TotalVoltageDropMaxLoad),
            motorNPVolts
          )
        ).pipe(
          map((data) => {
            return setSurfaceVoltage(data);
          })
        );
      }
    )
  );
};

const fetchMotorLoadFrequency = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("calculations/calculateMotorLoadFrequency"),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
      state$.pipe(map((state: RootState) => state?.surfaceEquipment)),
      state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
      state$.pipe(
        map((state: RootState) => state?.cable?.cableTotalVoltageLoss)
      ),
      state$.pipe(map((state: RootState) => state?.motor?.motor_HPInput)),
      state$.pipe(
        map((state: RootState) => state?.calculations?.schematicData)
      ),
      state$.pipe(map((state: RootState) => state?.motor?.MotorperformanceList))
    ),
    switchMap(
      ([
        actionData,
        tab1Input,
        surfaceEquipment,
        tab3Input,
        motorLoad,
        motorHpRequest,
        schematicsData,
        MotorperformanceList,
      ]) => {
        let transformer = surfaceEquipment?.Transformer?.find(
          (transformer: any) =>
            transformer?.id === surfaceEquipment?.SelectedTransformer?.id
        );
        let selectedVSD = surfaceEquipment?.VSDList?.find(
          (x: any) => x.vsD_ID == tab1Input?.hiddenSurfVSD
        );

        const motor: MotorLoadDifferentFrequencyRequest = {
          rmsVsdVolt: tab1Input?.hdnSurface_SuplVlt || 0,
          xformerMaxVolt: transformer?.sec_Y || 0,
          minFrequency: +schematicsData?.miscellaneous?.minFrequency || 0,
          designFrequency: tab3Input?.operatngFreq || 0,
          maxFrequency: +schematicsData?.miscellaneous?.maxFrequency || 0,
          vsdAmps: surfaceEquipment?.SelectedVSD?.current_OutField,
          motorNpAmp: MotorperformanceList?.[0]?.motorCurrent || 0,
          kva: selectedVSD?.powerField,
          pumpBHp: parseFloat(motorHpRequest),
          motorNPHP: MotorperformanceList?.[0]?.motorHP || 0,
          xformerCapacity: transformer?.kva || 0,
          totalVoltageDropMaxLoad: parseFloat(motorLoad),
          motorNPVolts: MotorperformanceList?.[0]?.motorVoltage || 0,
        };
        return from(
          calculationservice.GetMotorLoadDifferentFrequency(motor)
        ).pipe(
          map((data) => CalculationActions.setMotorLoadFrequencyData(data))
        );
      }
    )
  );
};
const saveProject = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("calculations/saveProjectData"),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state?.tubing?.tab1Input)),
      state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
      state$.pipe(map((state: RootState) => state?.fluid?.tab3Input)),
      state$.pipe(map((state: RootState) => state?.projectTab?.tab4Input)),
      state$.pipe(map((state: RootState) => state?.others)), // tab5Input
      state$.pipe(map((state: RootState) => state?.pump?.PumpModelE1)),
      state$.pipe(map((state: RootState) => state?.pump?.PumpInput)),
      state$.pipe(map((state: RootState) => state?.pump?.PumpInputCalculated)),
      state$.pipe(map((state: RootState) => state?.motor?.MotorInput)),
      //state$.pipe(map((state: RootState) => state?.helpobject)),////////////////help check it
      //state$.pipe(map((state: RootState) => state?.basicCalculations?.wellInflowData)),////////////////help check it
      state$.pipe(
        map((state: RootState) => state?.gasCalculations?.BasicGasCalculation)
      ),
      state$.pipe(
        map((state: RootState) => state?.gasCalculations?.GasCalculationOutPut)
      ),
      state$.pipe(
        map((state: RootState) => state?.basicCalculations?.basicTDHCalculation)
      ),
      state$.pipe(
        map((state: RootState) => state?.basicCalculations?.depletionPressure)
      ),
      state$.pipe(
        map(
          (state: RootState) => state?.basicCalculations?.futureProductionRate
        )
      ),
      state$.pipe(
        map(
          (state: RootState) =>
            state?.basicCalculations?.showDepletionPlotInMainReport
        )
      ),
      state$.pipe(
        map(
          (state: RootState) =>
            state?.basicCalculations?.showIPRPlotInMainReport
        )
      ),
      state$.pipe(map((state: RootState) => state?.wellSurvey?.wellSurveyData)), /////////// check it
      state$.pipe(
        map(
          (state: RootState) =>
            state?.calculations?.schematicData?.totalEspLength
        )
      ), /////////// check it
      state$.pipe(
        map(
          (state: RootState) => state?.calculations?.schematicData?.sensorDepth
        )
      ), /////////// check it
      state$.pipe(map((state: RootState) => state?.wellSurvey?.KOPOverride)), /////////// check it
      state$.pipe(map((state: RootState) => state?.wellSurvey?.TailPipeLength)), /////////// check it
      state$.pipe(
        map((state: RootState) => state?.wellSurvey?.showWellDataInMainReport)
      ),
      state$.pipe(
        map((state: RootState) => state?.wellSurvey?.wellSurvey?.notes)
      ),
      state$.pipe(
        map((state: RootState) => state?.surfaceEquipment?.HarmonicFilter)
      ),
      state$.pipe(
        map(
          (state: RootState) =>
            state?.gasCalculations?.GasCalculationOutPut
              ?.Intake_NaturalSeperatorEff
        )
      ),
      state$.pipe(map((state: RootState) => state?.fluid?.region)),
      state$.pipe(
        map((state: RootState) => state?.pump?.CompPumpInputCalculated)
      ),
      state$.pipe(map((state: RootState) => state?.createProject)),
      state$.pipe(map((state: RootState) => state?.myProjects?.templateID)),
      state$.pipe(map((state: RootState) => state?.comparison)),
      state$.pipe(
        map((state: RootState) => state?.myProjects?.selectedProject?.projectID)
      ),
      state$.pipe(map((state: RootState) => state?.calculations?.aiEnabled)),
      state$.pipe(map((state: RootState) => state?.projectHeader?.projectAndAffiliations))
    ),
    switchMap(
      ([
        actionData,
        tab1Input,
        tab2Input,
        tab3Input,
        tab4Input,
        tab5Input,
        pumpModelE1,
        pumpInput,
        pmpCalculatedData,
        motorInput,
        //helpOutObject,
        //basicWellInflowCalculation,
        basicGasCalculation,
        gasOutPut,
        basicTDHCalculation,
        depletionPressure,
        futureProductionRate,
        showDepletionPlotInMainReport,
        showIPRPlotInMainReport,
        wellSurveyData,
        espLength,
        bottomOfESPSensor,
        kop,
        tailPipeDesander,
        showWellDataInMainReport,
        wellSurveyNotes,
        HarmonicFilterIO,
        intakeNaturalSeparatorEff,
        region,
        CompPumpInputCalculated,
        ProjectDetails,
        templateID,
        caseComparison,
        DefaultProjectID,
        aiEnabled,
        projectAndAffiliations,
      ]) => {
        const helpOutObject = {
          description: "",
          link: "",
          className: "",
        };
        let basicWellInflowCalculation: any;
        const BEPFlow =
          pumpModelE1?.bepFlow == undefined
            ? ""
            : pumpModelE1?.bepFlow?.toString();

        const BHPPerStage =
          pumpModelE1?.bHPPerStage == undefined
            ? ""
            : pumpModelE1?.bHPPerStage?.toString();

        const Effeciency =
          pumpModelE1?.effeciency == undefined
            ? ""
            : pumpModelE1?.effeciency?.toString();

        const HSShaftHPLimit =
          pumpModelE1?.hsshaftHPLimit == undefined
            ? ""
            : pumpModelE1?.hsshaftHPLimit?.toString();

        const PumpID =
          pumpModelE1?.pumpID == undefined
            ? ""
            : pumpModelE1?.pumpID?.toString();

        const MaximumOperatingBPD =
          pumpModelE1?.maximumOperatingBPD == undefined
            ? ""
            : pumpModelE1?.maximumOperatingBPD?.toString();

        const MinimumOperatingBPD =
          pumpModelE1?.minimumOperatingBPD == undefined
            ? ""
            : pumpModelE1?.minimumOperatingBPD;

        const NumberOfStages =
          pumpModelE1?.numberOfStages == undefined
            ? ""
            : pumpModelE1?.numberOfStages?.toString();

        const PumpName =
          pumpModelE1?.pumpName == undefined ? "" : pumpModelE1?.pumpName;

        const ShaftDiameter =
          pumpModelE1?.shaftDiameter == undefined
            ? ""
            : pumpModelE1?.shaftDiameter;

        const StandardShaftHPLimit =
          pumpModelE1?.standardShaftHPLimit == undefined
            ? ""
            : pumpModelE1?.standardShaftHPLimit?.toString();

        const LiftPerStage =
          pumpModelE1?.liftPerStage == undefined
            ? ""
            : pumpModelE1?.liftPerStage?.toString();

        const PumpImpellar =
          pumpModelE1?.pumpImpellar == undefined
            ? ""
            : pumpModelE1?.pumpImpellar?.toString();

        const TotalBHP =
          pumpModelE1?.totalBHP == undefined
            ? ""
            : pumpModelE1?.totalBHP?.toString();

        const PumpSeries =
          pumpModelE1?.pumpSeries == undefined
            ? ""
            : pumpModelE1?.pumpSeries?.toString();

        const Pump_SpGravity = pumpInput?.pump_SpGravity ?? 0;

        const Pump_FldViscosity = pumpInput?.pump_FldViscosity ?? 0;

        const Pump_OperatngFreq =
          pumpInput?.pump_OperatngFreq == undefined
            ? 0
            : pumpInput?.pump_OperatngFreq;

        const Pump_FullLoadSp = pumpInput?.pump_FullLoadSp ?? 3500;

        const Pump_DesredFlwRate = pumpInput?.pump_DesredFlwRate ?? 0;

        const Pump_ReqdTDH = pumpInput?.pump_ReqdTDH ?? "";

        const Pump_ShaftType = pumpInput?.pump_ShaftType ?? "";

        const Pump_PumpName = pumpInput?.pump_PumpName ?? "";

        const Pump_DesrdStges = pumpInput?.pump_DesrdStges ?? "";

        const UnitPmp_OperatngFrq = pumpInput?.unitPmp_OperatngFrq ?? "";

        const UnitPmp_LftPrStage = pumpInput?.unitPmp_LftPrStage ?? "";

        const ActNamePump_DesiredFlowRate =
          pumpInput?.actNamePump_DesiredFlowRate ?? "";

        const ActNamePump_FluidViscosity =
          pumpInput?.actNamePump_FluidViscosity ?? "";

        const ActNamePump_HP3500 = pumpInput?.actNamePump_HP3500 ?? "";

        const ActNamePump_MotorFullSpeed =
          pumpInput?.actNamePump_MotorFullSpeed ?? "";

        const ActNamePump_OperatingFrequency =
          pumpInput?.actNamePump_OperatingFrequency ?? "";

        const ActNamePump_RequiredTDH =
          pumpInput?.actNamePump_RequiredTDH ?? "";

        const UnitPmp_MtrFlSpd = pumpInput?.unitPmp_MtrFlSpd ?? "";

        const UnitPmp_HP3500 = pumpInput?.unitPmp_HP3500 ?? "";

        const UnitPmp_FldViscty = pumpInput?.unitPmp_FldViscty ?? "";

        const UnitPmp_DesrdFlRate = pumpInput?.unitPmp_DesrdFlRate ?? "";

        const UnitPmp_ReqTDH = pumpInput?.unitPmp_ReqTDH ?? "";

        const ActNamePump_LiftPerStage =
          pumpInput?.actNamePump_LiftPerStage ?? "";

        const ActNamePump_Pmax = pumpInput?.actNamePump_Pmax;

        const ActNamePump_PressureLimit =
          pumpInput?.actNamePump_PressureLimit ?? "";

        const Motor_HPInput = motorInput?.motor_HPInput;

        const Motor_HP60Input =
          motorInput?.motor_HP60Input == undefined
            ? ""
            : motorInput?.motor_HP60Input;

        const MotorLoadInput = motorInput?.motorLoad;

        const Description =
          helpOutObject.description == undefined
            ? ""
            : helpOutObject.description;

        const Link = helpOutObject.link == undefined ? "" : helpOutObject.link;

        const ClassName = tab1Input?.className || "";

        const ESPLength = espLength ?? "";
        const BottomOfESPSensor = bottomOfESPSensor ?? "";
        const kOP = kop ?? "";
        const TailPipeDesander = tailPipeDesander ?? "";
        const ShowWellDataInMainReport = showWellDataInMainReport ?? false;
        const Notes = wellSurveyNotes ?? "";
        const InstallationType = HarmonicFilterIO?.InstallationType;
        const EstimatedCurrentAmps = HarmonicFilterIO?.EstimatedCurrentAmps;
        const FilterSelection = HarmonicFilterIO?.FilterSelection;
        const IntakeNaturalSeparatorEff = intakeNaturalSeparatorEff ?? 0;

        // let chargePump3List: { [key: string]: string } = {};
        // ChargePumpList3.map((item: any) => {
        //   chargePump3List = { ...chargePump3List, [item.label]: item.value };

        // });

        tab1Input = Object.assign(
          {},
          {
            ...tab1Input,
            GKXFlowCorrection: gasOutPut?.GKX_FlowCorrection,
            GKXHeadCorrection: gasOutPut?.GKX_HeadCorrection,
            GKXPowerCorrection: gasOutPut?.GKX_PowerCorrection,
            CP1FlowCorrection: gasOutPut?.CP1_FlowCorrection,
            CP1HeadCorrection: gasOutPut?.CP1_HeadCorrection,
            CP1PowerCorrection: gasOutPut?.CP1_PowerCorrection,
            CP2FlowCorrection: gasOutPut?.CP2_FlowCorrection,
            CP2HeadCorrection: gasOutPut?.CP2_HeadCorrection,
            CP2PowerCorrection: gasOutPut?.CP2_PowerCorrection,
            CP3FlowCorrection: gasOutPut?.CP3_FlowCorrection,
            CP3HeadCorrection: gasOutPut?.CP3_HeadCorrection,
            CP3PowerCorrection: gasOutPut?.CP3_PowerCorrection,
            Hdn_Pump_HousingType: tab1Input?.hdn_Pump_HousingType,
            Hdn_Pump_ShaftType: tab1Input?.hdn_Pump_ShaftType,
            HdnSurface_Efficiency: tab1Input?.hdnSurface_Efficiency,
            linerODList: {},
            tubingODList: {},
            tubingTypeList: {},
            casingODList: {},
            linerWeightList: {},
            casingWeightList: {},
            tubingWeightList: {},
            wellTrajectoryList: {},
            tubingTypeUpsetList: {},
          }
        );
        tab4Input = Object.assign(
          {},
          {
            ...tab4Input,
            companyName: ProjectDetails?.customer,
            customerContact: ProjectDetails?.contact,
            wellName: ProjectDetails?.well,
            country: ProjectDetails?.country,
            state: ProjectDetails?.state,
            dalRepr: ProjectDetails?.accountManager,
            formation: ProjectDetails?.formation,
            ProjectName: ProjectDetails?.projectName,
            countryList: {},
            stateList: {},
            countyList: {},
          }
        );
        let NameSearch: any = {
          CompanyName: tab4Input?.companyName,
          CustomerContact: tab4Input?.customerContact,
          WellName: tab4Input?.wellName,
          Country: tab4Input?.country,
          State: tab4Input?.state,
          CatalogType: +tab1Input?.catalogType || 0,
          DalRep: tab4Input?.dalRepr,
          Formation: tab4Input?.formation,
          ProjectID: actionData?.payload, ///////////////////////project id get from store
          Tab1Input: tab1Input,
          Tab2Input: tab2Input,
          Tab3Input: tab3Input,
          Tab4Input: tab4Input,
          Tab5Input: tab5Input,
          pumpModelE1: [
            {
              BEPFlow: BEPFlow,
              BHPPerStage: BHPPerStage,
              Effeciency: Effeciency,
              HSShaftHPLimit: HSShaftHPLimit,
              PumpID: PumpID,
              LiftPerStage: LiftPerStage,
              MaximumOperatingBPD: MaximumOperatingBPD,
              MinimumOperatingBPD: MinimumOperatingBPD,
              NumberOfStages: NumberOfStages,
              PumpName: PumpName,
              ShaftDiameter: ShaftDiameter,
              StandardShaftHPLimit: StandardShaftHPLimit,
              TotalBHP: TotalBHP,
              PumpImpellar: PumpImpellar,
              PumpSeries: PumpSeries,
            },
          ],
          PumpInput: {
            PumpFlowCorrection: pmpCalculatedData?.flwCrrctnForPump,
            PumpHeadCorrection: pmpCalculatedData?.hdCrrctnForPump,
            PumpPowerCorrection: pmpCalculatedData?.pWRCrrctnForPump,
            Pump_SpGravity: Pump_SpGravity,
            Pump_FldViscosity: Pump_FldViscosity,
            Pump_OperatngFreq: Pump_OperatngFreq,
            Pump_FullLoadSp: Pump_FullLoadSp,
            Pump_DesredFlwRate: Pump_DesredFlwRate,
            Pump_ReqdTDH: Pump_ReqdTDH,
            Pump_DesrdStges: Pump_DesrdStges,
            Pump_PumpName: Pump_PumpName,
            Pump_ShaftType: Pump_ShaftType,
            UnitPmp_DesrdFlRate: UnitPmp_DesrdFlRate,
            UnitPmp_FldViscty: UnitPmp_FldViscty,
            UnitPmp_HP3500: UnitPmp_HP3500,
            UnitPmp_MtrFlSpd: UnitPmp_MtrFlSpd,
            UnitPmp_OperatngFrq: UnitPmp_OperatngFrq,
            UnitPmp_ReqTDH: UnitPmp_ReqTDH,
            UnitPmp_LftPrStage: UnitPmp_LftPrStage,
            ActNamePump_DesiredFlowRate: ActNamePump_DesiredFlowRate,
            ActNamePump_FluidViscosity: ActNamePump_FluidViscosity,
            ActNamePump_HP3500: ActNamePump_HP3500,
            ActNamePump_MotorFullSpeed: ActNamePump_MotorFullSpeed,
            ActNamePump_OperatingFrequency: ActNamePump_OperatingFrequency,
            ActNamePump_RequiredTDH: ActNamePump_RequiredTDH,
            ActNamePump_LiftPerStage: ActNamePump_LiftPerStage,
            ActNamePump_Pmax: ActNamePump_Pmax,
            ActNamePump_PressureLimit: ActNamePump_PressureLimit,
            InstallationType: InstallationType,
            EstimatedCurrentAmps: EstimatedCurrentAmps,
            FilterSelection: FilterSelection,
            CompositePumpFlowCorrection:
              CompPumpInputCalculated?.compositeFlowCorrectionFactor,
            CompositePumpHeadCorrection:
              CompPumpInputCalculated?.compositeHeadCorrectionFactor,
            CompositePumpPowerCorrection:
              CompPumpInputCalculated?.compositePowerCorrectionFactor,
          },
          MotorInput: {
            Motor_HPInput: Motor_HPInput,
            Motor_HP60Input: Motor_HP60Input,
            MotorLoad: MotorLoadInput,
          },
          HelpObj: {
            Description: Description,
            Link: Link,
            ClassName: ClassName,
          },
          WellSurveyESPAssembly: {
            ESPLength: ESPLength,
            kOP: kOP,
            BottomOfESPSensor: BottomOfESPSensor,
            TailPipeDesander: TailPipeDesander,
            ShowWellDataInMainReport: ShowWellDataInMainReport,
            Notes: Notes,
          },
        };

        const CalMethod =
          basicWellInflowCalculation?.calMethod == undefined
            ? ""
            : basicWellInflowCalculation?.calMethod?.toString();

        const CalMethodList =
          basicWellInflowCalculation?.calMethodList == undefined
            ? {}
            : basicWellInflowCalculation?.calMethodList;

        const UnitIntakeHeadListVal =
          basicWellInflowCalculation?.unitIntakeHeadListVal == undefined
            ? ""
            : basicWellInflowCalculation?.unitIntakeHeadListVal?.toString();

        const ReservoirHead =
          basicWellInflowCalculation?.reservoirHead == undefined
            ? ""
            : basicWellInflowCalculation?.reservoirHead?.toString();

        const IntakeHead =
          basicWellInflowCalculation?.intakeHead == undefined
            ? ""
            : basicWellInflowCalculation?.intakeHead?.toString();

        const UnitReservoirHeadListVal =
          basicWellInflowCalculation?.unitReservoirHeadListVal == undefined
            ? ""
            : basicWellInflowCalculation?.unitReservoirHeadListVal?.toString();

        const AdditionalBPD =
          basicWellInflowCalculation?.additionalBPD == undefined
            ? ""
            : basicWellInflowCalculation?.additionalBPD?.toString();

        const MaxFlowRate =
          basicWellInflowCalculation?.maxFlowRate == undefined
            ? ""
            : basicWellInflowCalculation?.maxFlowRate?.toString();

        const UnitAdditionalBPDListVal =
          basicWellInflowCalculation?.unitAdditionalBPDListVal == undefined
            ? ""
            : basicWellInflowCalculation?.unitAdditionalBPDListVal?.toString();

        const ActNameBasic_ReservoirHead =
          basicWellInflowCalculation?.actNameBasic_ReservoirHead == undefined
            ? ""
            : basicWellInflowCalculation?.actNameBasic_ReservoirHead?.toString();

        const UnitMaxFlowRateListVal =
          basicWellInflowCalculation?.unitMaxFlowRateListVal == undefined
            ? ""
            : basicWellInflowCalculation?.unitMaxFlowRateListVal?.toString();

        const ActNameBasic_IntakeHead =
          basicWellInflowCalculation?.actNameBasic_IntakeHead == undefined
            ? ""
            : basicWellInflowCalculation?.actNameBasic_IntakeHead?.toString();

        const GasDesign = basicGasCalculation?.gasDesign ?? "0";

        const PreAnchorFreeGas =
          basicGasCalculation?.preAnchorFreeGas == undefined
            ? ""
            : basicGasCalculation?.preAnchorFreeGas?.toString();

        const PreAnchorTFV =
          basicGasCalculation?.preAnchorTFV == undefined
            ? ""
            : basicGasCalculation?.preAnchorTFV?.toString();

        const ChargePmpSepGVF =
          basicGasCalculation?.chargePmpSepGVF == undefined
            ? ""
            : basicGasCalculation?.chargePmpSepGVF?.toString();

        const ChargePmpSepFreeGas =
          basicGasCalculation?.chargePmpSepFreeGas == undefined
            ? ""
            : basicGasCalculation?.chargePmpSepFreeGas?.toString();

        const PreAnchorGOR =
          basicGasCalculation?.preAnchorGOR == undefined
            ? ""
            : basicGasCalculation?.preAnchorGOR?.toString();

        const PreAnchorGLR =
          basicGasCalculation?.preAnchorGLR == undefined
            ? ""
            : basicGasCalculation?.preAnchorGLR?.toString();

        const PreAnchorNaturalEfficiency =
          basicGasCalculation?.preAnchorNaturalEfficiency == undefined
            ? ""
            : basicGasCalculation?.preAnchorNaturalEfficiency?.toString();

        const ChargePumpDesrdStge3 =
          basicGasCalculation?.chargePumpDesrdStge3 == undefined
            ? ""
            : basicGasCalculation?.chargePumpDesrdStge3?.toString();

        const ChargePumpDesrdStge2 =
          basicGasCalculation?.chargePumpDesrdStge2 == undefined
            ? ""
            : basicGasCalculation?.chargePumpDesrdStge2?.toString();

        const ChargePumpDesrdStge =
          basicGasCalculation?.chargePumpDesrdStge == undefined
            ? ""
            : basicGasCalculation?.chargePumpDesrdStge?.toString();

        const AnchorOD = basicGasCalculation?.anchorOD ?? "";

        const GasDesignList =
          basicGasCalculation?.gasDesignList == undefined
            ? {}
            : basicGasCalculation?.gasDesignList;

        const AnchorID = basicGasCalculation?.anchorID ?? "";

        const AnchorODList =
          basicGasCalculation?.anchorODList == undefined
            ? {}
            : basicGasCalculation?.anchorODList;

        const TubingOD = basicGasCalculation?.tubingOD ?? "";

        const AnchorTubingOD = basicGasCalculation?.tubingOD ?? "";

        const AnchorTubingODList =
          basicGasCalculation?.anchorTubingODList == undefined
            ? {}
            : basicGasCalculation?.anchorTubingODList;

        const LiqdPhaseDensity =
          basicGasCalculation?.unitLiqPhseDens == undefined
            ? ""
            : basicGasCalculation?.unitLiqPhseDens?.toString();

        const ChargePumpHdPrStage =
          basicGasCalculation?.chargePumpHdPrStage == undefined
            ? ""
            : basicGasCalculation?.chargePumpHdPrStage?.toString();

        const ActNameGas_GasVolume =
          basicGasCalculation?.actNameGas_GasVolume == undefined
            ? ""
            : basicGasCalculation?.actNameGas_GasVolume?.toString();

        const ActNameGas_Bo =
          basicGasCalculation?.actNameGas_Bo == undefined
            ? ""
            : basicGasCalculation?.actNameGas_Bo?.toString();

        const ActNameGas_Bg =
          basicGasCalculation?.actNameGas_Bg == undefined
            ? ""
            : basicGasCalculation?.actNameGas_Bg?.toString();

        const ActNameGas_OilVolume =
          basicGasCalculation?.actNameGas_OilVolume == undefined
            ? ""
            : basicGasCalculation?.actNameGas_OilVolume?.toString();

        const ActNameGas_PressureContribution =
          basicGasCalculation?.actNameGas_PressureContribution == undefined
            ? ""
            : basicGasCalculation?.actNameGas_PressureContribution?.toString();

        const FinTemp =
          basicGasCalculation?.finTemp == undefined
            ? ""
            : basicGasCalculation?.finTemp?.toString();

        const ActNameGas_FreeGas =
          basicGasCalculation?.actNameGas_FreeGas == undefined
            ? ""
            : basicGasCalculation?.actNameGas_FreeGas?.toString();

        const ChargePmpSepTFV =
          basicGasCalculation?.chargePmpSepTFV == undefined
            ? ""
            : basicGasCalculation?.chargePmpSepTFV?.toString();

        const NaturalEfficiency =
          basicGasCalculation?.naturalEfficiency == undefined
            ? ""
            : basicGasCalculation?.naturalEfficiency?.toString();

        const TotalFluidVolume =
          basicGasCalculation?.totalFluidVolumeHand == undefined
            ? ""
            : basicGasCalculation?.totalFluidVolumeHand?.toString();

        const SeparatorEfficiency =
          basicGasCalculation?.separatorEfficiency == undefined
            ? ""
            : basicGasCalculation?.separatorEfficiency?.toString();

        const TotalPIP =
          basicGasCalculation?.totalPIP == undefined
            ? ""
            : basicGasCalculation?.totalPIP?.toString();

        const WaterVolume =
          basicGasCalculation?.waterVolume == undefined
            ? ""
            : basicGasCalculation?.waterVolume?.toString();

        const OilVolume =
          basicGasCalculation?.oilVolume == undefined
            ? ""
            : basicGasCalculation?.oilVolume?.toString();

        const Bo =
          basicGasCalculation?.bo == undefined
            ? ""
            : basicGasCalculation?.bo?.toString();

        const Rs = gasOutPut?.Intake_Rs ?? "";

        const Bg =
          basicGasCalculation?.bg == undefined
            ? ""
            : basicGasCalculation?.bg?.toString();

        const GOR = tab3Input?.gor == undefined ? 0 : tab3Input?.gor;

        const CombinedSpGr =
          tab3Input?.combinedSpGr == undefined ? "" : tab3Input?.combinedSpGr;

        tab3Input?.unitBOPDListVal?.toString();

        const NaturalEfficiencyAnchor =
          basicGasCalculation?.naturalEfficiencyAnchor == undefined
            ? ""
            : basicGasCalculation?.naturalEfficiencyAnchor?.toString();

        const GasVolIngested =
          basicGasCalculation?.gasVolIngested == undefined
            ? ""
            : basicGasCalculation?.gasVolIngested?.toString();

        const LiqVolmRate =
          basicGasCalculation?.liqVolmRate == undefined
            ? ""
            : basicGasCalculation?.liqVolmRate?.toString();

        const TotalFluidVolumeHand =
          basicGasCalculation?.totalFluidVolumeHand == undefined
            ? ""
            : basicGasCalculation?.totalFluidVolumeHand?.toString();

        const FreeGasPercentge =
          basicGasCalculation?.freeGasPercentge == undefined
            ? ""
            : basicGasCalculation?.freeGasPercentge?.toString();

        const GVFPreSep =
          basicGasCalculation?.gvfPreSep == undefined
            ? ""
            : basicGasCalculation?.gvfPreSep?.toString();

        const GLRPreSep =
          basicGasCalculation?.glrPreSep == undefined
            ? ""
            : basicGasCalculation?.glrPreSep?.toString();

        const PrePressGrad =
          basicGasCalculation?.prePressGrad == undefined
            ? ""
            : basicGasCalculation?.prePressGrad?.toString();

        const GORPreSep =
          basicGasCalculation?.gorPreSep == undefined
            ? ""
            : basicGasCalculation?.gorPreSep?.toString();
        const ChargePump_ShowAll = tab1Input?.chargePumpShowAll ?? false;

        const FLOP =
          basicGasCalculation?.flop == undefined
            ? ""
            : basicGasCalculation?.flop?.toString();

        const UnitAnchorIDListVal =
          basicGasCalculation?.unitAnchorIDListVal == undefined
            ? ""
            : basicGasCalculation?.unitAnchorIDListVal?.toString();

        const ChargePumpPresGrad =
          basicGasCalculation?.chargePumpPresGrad == undefined
            ? ""
            : basicGasCalculation?.chargePumpPresGrad?.toString();

        const ChargePumpGLR =
          basicGasCalculation?.chargePumpGLR == undefined
            ? ""
            : basicGasCalculation?.chargePumpGLR?.toString();

        const ChargePmpTotalPressure =
          basicGasCalculation?.chargePmpTotalPressure == undefined
            ? ""
            : basicGasCalculation?.chargePmpTotalPressure?.toString();

        const ChargePmpPSI =
          basicGasCalculation?.chargePmpPSI == undefined
            ? ""
            : basicGasCalculation?.chargePmpPSI?.toString();

        const UnitPressGrdnt =
          basicGasCalculation?.unitPressGrdnt == undefined
            ? ""
            : basicGasCalculation?.unitPressGrdnt?.toString();

        const UnitLiqPhseDens =
          basicGasCalculation?.unitLiqPhseDens == undefined
            ? ""
            : basicGasCalculation?.unitLiqPhseDens?.toString();

        const ActNameGas_AnchorOD =
          basicGasCalculation?.actNameGas_AnchorOD == undefined
            ? ""
            : basicGasCalculation?.actNameGas_AnchorOD?.toString();

        const ActNameGas_AnchorID =
          basicGasCalculation?.actNameGas_AnchorID == undefined
            ? ""
            : basicGasCalculation?.actNameGas_AnchorID?.toString();

        const ActNameGas_AnchorTubingOD =
          basicGasCalculation?.actNameGas_AnchorTubingOD == undefined
            ? ""
            : basicGasCalculation?.actNameGas_AnchorTubingOD?.toString();

        const ActNameGas_SeparatorHP =
          basicGasCalculation?.actNameGas_SeparatorHP == undefined
            ? ""
            : basicGasCalculation?.actNameGas_SeparatorHP?.toString();

        const ActNameGas_ChargePumpHP =
          basicGasCalculation?.actNameGas_ChargePumpHP == undefined
            ? ""
            : basicGasCalculation?.actNameGas_ChargePumpHP?.toString();

        const ActNameGas_HeadPerStage =
          basicGasCalculation?.actNameGas_HeadPerStage == undefined
            ? ""
            : basicGasCalculation?.actNameGas_HeadPerStage?.toString();

        const ActNameGas_SeparationEfficiency =
          basicGasCalculation?.actNameGas_SeparationEfficiency == undefined
            ? ""
            : basicGasCalculation?.actNameGas_SeparationEfficiency?.toString();

        const ActNameGas_PressureGradient =
          basicGasCalculation?.actNameGas_PressureGradient == undefined
            ? ""
            : basicGasCalculation?.actNameGas_PressureGradient?.toString();

        const ActNameGas_TotalFluidVolume =
          basicGasCalculation?.actNameGas_TotalFluidVolume == undefined
            ? ""
            : basicGasCalculation?.actNameGas_TotalFluidVolume?.toString();

        const ActNameGas_GOR =
          basicGasCalculation?.actNameGas_GOR == undefined
            ? ""
            : basicGasCalculation?.actNameGas_GOR?.toString();

        const ActNameGas_GLR =
          basicGasCalculation?.actNameGas_GLR == undefined
            ? ""
            : basicGasCalculation?.actNameGas_GLR?.toString();

        const ActNameGas_GVF =
          basicGasCalculation?.actNameGas_GVF == undefined
            ? ""
            : basicGasCalculation?.actNameGas_GVF?.toString();

        const ActNameGas_VolumeInjested =
          basicGasCalculation?.actNameGas_VolumeInjested == undefined
            ? ""
            : basicGasCalculation?.actNameGas_VolumeInjested?.toString();

        const ActNameGas_Rs =
          basicGasCalculation?.actNameGas_Rs == undefined
            ? ""
            : basicGasCalculation?.actNameGas_Rs?.toString();

        const ActNameGas_LiquidVolumetricRate =
          basicGasCalculation?.actNameGas_LiquidVolumetricRate == undefined
            ? ""
            : basicGasCalculation?.actNameGas_LiquidVolumetricRate?.toString();

        const ActNameGas_WaterVolume =
          basicGasCalculation?.actNameGas_WaterVolume == undefined
            ? ""
            : basicGasCalculation?.actNameGas_WaterVolume?.toString();

        const ActNameGas_LiquidPhaseDensity =
          basicGasCalculation?.actNameGas_LiquidPhaseDensity == undefined
            ? ""
            : basicGasCalculation?.actNameGas_LiquidPhaseDensity?.toString();

        const ChargePumpGKX = basicGasCalculation?.chargePumpGKX;

        //const ChargePumpGKXList = basicGasCalculation?.chargePumpGKXList == undefined ? {} : basicGasCalculation?.chargePumpGKXList;
        const ChargePumpGKXList = {};

        const ChargePump =
          basicGasCalculation?.chargePump == undefined
            ? ""
            : basicGasCalculation?.chargePump?.toString();
        const ChrgePmpGasVolume =
          basicGasCalculation?.chrgePmpGasVolume == undefined
            ? ""
            : basicGasCalculation?.chrgePmpGasVolume?.toString();

        const NoOfGasSeps = basicGasCalculation?.noOfGasSeps;

        const ChargePump2 = basicGasCalculation?.chargePump2 ?? "";

        //const ChargePumpList = basicGasCalculation?.chargePumpList == undefined ? {} : basicGasCalculation?.chargePumpList;

        const ChargePumpList = {};
        const SepSelcted = basicGasCalculation?.sepSelcted ?? "";

        //const SeparatorList = basicGasCalculation?.separatorList == undefined ? {} : basicGasCalculation?.separatorList;
        const SeparatorList = {};

        //const ChargePumpList2 = basicGasCalculation?.chargePumpList2 == undefined ? {} : basicGasCalculation?.chargePumpList2;
        const ChargePumpList2 = {};
        const ChargePump3 = basicGasCalculation?.chargePump3 ?? "";

        //let ChargePumpList3 = basicGasCalculation?.chargePumpList3 == undefined ? {} : basicGasCalculation?.chargePumpList3;
        const ChargePumpList3 = {};
        // let sepList: { [key: string]: Separator } = {};

        // SeparatorList.map((item: any) => {
        //   let namee = item.name;
        //   let obj =
        //   {
        //     id: item?.id,
        //     series: item?.series,
        //     seriesType: item?.seriesType,
        //   }
        //   sepList = { ...sepList, [namee]: obj };
        // });

        // let chargePump1List: { [key: string]: string } = {};
        // ChargePumpList.map((item: any) => {
        //   chargePump1List = { ...chargePump1List, [item.label]: item.value };

        // });

        // let chargePump2List: { [key: string]: string } = {};
        // ChargePumpList2.map((item: any) => {
        //   chargePump2List = { ...chargePump2List, [item.label]: item.value };

        // });

        // let chargePump3List: { [key: string]: string } = {};
        // ChargePumpList3.map((item: any) => {
        //   chargePump3List = { ...chargePump3List, [item.label]: item.value };

        // });

        const UseOfChgPmp = basicGasCalculation?.useOfChgPmp;

        const UseOfChgPmpNew = basicGasCalculation?.useOfChgPmpNew;

        const NoOfStages =
          basicGasCalculation?.noOfStages == undefined
            ? ""
            : basicGasCalculation?.noOfStages?.toString();

        const PreAnchorGVF =
          basicGasCalculation?.preAnchorGVF == undefined
            ? ""
            : basicGasCalculation?.preAnchorGVF?.toString();

        const GasCompressblty =
          basicGasCalculation?.gasCompressblty == undefined
            ? ""
            : basicGasCalculation?.gasCompressblty?.toString();
        const ChargePmpSepGOR =
          basicGasCalculation?.chargePmpSepGOR == undefined
            ? ""
            : basicGasCalculation?.chargePmpSepGOR?.toString();

        const ActNameGas_TotalPressure =
          basicTDHCalculation?.actNameGas_TotalPressure == undefined
            ? ""
            : basicTDHCalculation?.actNameGas_TotalPressure?.toString();

        const ActNamebasic_Flop =
          basicTDHCalculation?.actNamebasic_Flop == undefined
            ? ""
            : basicTDHCalculation?.actNamebasic_Flop?.toString();

        const ActNameBasic_PIP =
          basicTDHCalculation?.actNameBasic_PIP == undefined
            ? ""
            : basicTDHCalculation?.actNameBasic_PIP?.toString();

        const ActNameBasic_ProductionLevel =
          basicTDHCalculation?.actNameBasic_ProductionLevel == undefined
            ? ""
            : basicTDHCalculation?.actNameBasic_ProductionLevel?.toString();

        const ActNameBasic_FrictionLoss =
          basicTDHCalculation?.actNameBasic_FrictionLoss == undefined
            ? ""
            : basicTDHCalculation?.actNameBasic_FrictionLoss?.toString();

        const TDH = basicTDHCalculation?.tdh ?? "";

        const UnitTDHOverrideList =
          basicTDHCalculation?.unitTDHOverrideList == undefined
            ? ""
            : basicTDHCalculation?.unitTDHOverrideList?.toString();

        const ActNameBasic_TDH =
          basicTDHCalculation?.actNameBasic_TDH == undefined
            ? ""
            : basicTDHCalculation?.actNameBasic_TDH?.toString();

        const ActNameMotor_T1OperatingTemp =
          tab1Input?.actNameMotor_T1OperatingTemp == undefined
            ? ""
            : tab1Input?.actNameMotor_T1OperatingTemp?.toString();

        const TDHOverride =
          basicTDHCalculation?.tdhOverride == undefined
            ? ""
            : basicTDHCalculation?.tdhOverride?.toString();

        const TubingHead = basicTDHCalculation?.tubingHead ?? "";

        const FrictionLoss = basicTDHCalculation?.frictionLoss ?? "";

        const ProductionLevel = basicTDHCalculation?.productionLevel ?? "";

        const UnitPIPListVal =
          basicTDHCalculation?.unitPIPListVal == undefined
            ? ""
            : basicTDHCalculation?.unitPIPListVal?.toString();

        const ActNameBasic_TubingHead =
          basicTDHCalculation?.actNameBasic_TubingHead == undefined
            ? ""
            : basicTDHCalculation?.actNameBasic_TubingHead?.toString();

        const UnitProductionLevelListVal =
          basicTDHCalculation?.unitProductionLevelListVal == undefined
            ? ""
            : basicTDHCalculation?.unitProductionLevelListVal?.toString();

        const UnitFrictionLossListVal =
          basicTDHCalculation?.unitFrictionLossListVal == undefined
            ? ""
            : basicTDHCalculation?.unitFrictionLossListVal?.toString();

        const UnitTubingHeadListVal =
          basicTDHCalculation?.unitTubingHeadListVal == undefined
            ? ""
            : basicTDHCalculation?.unitTubingHeadListVal?.toString();

        const UnitTDHOverrideListVal =
          basicTDHCalculation?.unitTDHOverrideListVal == undefined
            ? ""
            : basicTDHCalculation?.unitTDHOverrideListVal?.toString();

        const PIP = basicTDHCalculation?.pip ?? "";

        const NewTDH = basicTDHCalculation?.newTDH ?? "";

        const DesrdPIP = basicTDHCalculation?.desrdPIP ?? "";

        const PIPNew = basicTDHCalculation?.pipNew ?? "";

        const UnitTDHListVal =
          basicTDHCalculation?.unitTDHListVal == undefined
            ? ""
            : basicTDHCalculation?.unitTDHListVal?.toString();

        const Hdn_GKX_ShaftType = basicGasCalculation?.hdn_GKX_ShaftType;
        const Hdn_ChargePump1_ShaftType =
          basicGasCalculation?.hdn_ChargePump1_ShaftType;
        const Hdn_ChargePump2_ShaftType =
          basicGasCalculation?.hdn_ChargePump2_ShaftType;
        const Hdn_ChargePump3_ShaftType =
          basicGasCalculation?.hdn_ChargePump3_ShaftType;

        const SeatSearch: any = {
          BasicWellInflowCalculation: {
            CalMethod: CalMethod,
            CalMethodList: CalMethodList,
            ReservoirHead: ReservoirHead,
            IntakeHead: IntakeHead,
            MaxFlowRate: MaxFlowRate,
            AdditionalBPD: AdditionalBPD,
            UnitReservoirHeadListVal: UnitReservoirHeadListVal,
            UnitIntakeHeadListVal: UnitIntakeHeadListVal,
            UnitMaxFlowRateListVal: UnitMaxFlowRateListVal,
            UnitAdditionalBPDListVal: UnitAdditionalBPDListVal,
            ActNameBasic_ReservoirHead: ActNameBasic_ReservoirHead,
            ActNameBasic_IntakeHead: ActNameBasic_IntakeHead,
          },
          BasicGasCalculation: {
            GasDesign: GasDesign,
            GasDesignList: GasDesignList,
            AnchorOD: AnchorOD,
            AnchorODList: AnchorODList,
            AnchorID: AnchorID,
            TubingOD: TubingOD,
            AnchorTubingODList: AnchorTubingODList,
            NaturalEfficiency: NaturalEfficiency,
            SeparatorEfficiency: SeparatorEfficiency,
            Rs: Rs,
            Bg: Bg,
            Bo: Bo,
            OilVolume: OilVolume,
            WaterVolume: WaterVolume,
            TotalFluidVolume: TotalFluidVolume,
            GOR: GOR,
            NaturalEfficiencyAnchor: NaturalEfficiencyAnchor,
            GasVolIngested: GasVolIngested,
            LiqVolmRate: LiqVolmRate,
            TotalFluidVolumeHand: TotalFluidVolumeHand,
            FreeGasPercentge: FreeGasPercentge,
            GVFPreSep: GVFPreSep,
            GORPreSep: GORPreSep,
            GLRPreSep: GLRPreSep,
            PrePressGrad: PrePressGrad,
            LiqdPhaseDensity: LiqdPhaseDensity,
            TotalPIP: TotalPIP,
            CombinedSpGr: CombinedSpGr,
            FLOP: FLOP,
            ChargePumpGKX: ChargePumpGKX,
            ChargePumpGKXList: ChargePumpGKXList,
            ChargePump: ChargePump,
            ChargePumpList: ChargePumpList,
            ChargePump2: ChargePump2,
            ChargePumpList2: ChargePumpList2,
            ChargePump3: ChargePump3,
            ChargePumpList3: ChargePumpList3,
            SepSelcted: SepSelcted,
            SeparatorList: SeparatorList,
            NoOfGasSeps: NoOfGasSeps,
            UseOfChgPmp: UseOfChgPmp,
            UseOfChgPmpNew: UseOfChgPmpNew,
            NoOfStages: NoOfStages,
            ChargePumpHdPrStage: ChargePumpHdPrStage,
            ChargePumpDesrdStge: ChargePumpDesrdStge,
            ChargePumpDesrdStge2: ChargePumpDesrdStge2,
            ChargePumpDesrdStge3: ChargePumpDesrdStge3,
            PreAnchorNaturalEfficiency: PreAnchorNaturalEfficiency,
            PreAnchorGOR: PreAnchorGOR,
            PreAnchorGLR: PreAnchorGLR,
            PreAnchorGVF: PreAnchorGVF,
            PreAnchorFreeGas: PreAnchorFreeGas,
            PreAnchorTFV: PreAnchorTFV,
            ChrgePmpGasVolume: ChrgePmpGasVolume,
            ChargePmpSepTFV: ChargePmpSepTFV,
            ChargePmpSepFreeGas: ChargePmpSepFreeGas,
            ChargePmpSepGVF: ChargePmpSepGVF,
            ChargePmpSepGOR: ChargePmpSepGOR,
            ChargePmpPSI: ChargePmpPSI,
            ChargePmpTotalPressure: ChargePmpTotalPressure,
            ChargePumpGLR: ChargePumpGLR,
            ChargePumpPresGrad: ChargePumpPresGrad,
            UnitAdditionalBPDListVal: UnitAdditionalBPDListVal,
            UnitAnchorIDListVal: UnitAnchorIDListVal,
            UnitPressGrdnt: UnitPressGrdnt,
            UnitLiqPhseDens: UnitLiqPhseDens,
            ActNameGas_AnchorOD: ActNameGas_AnchorOD,
            ActNameGas_AnchorID: ActNameGas_AnchorID,
            ActNameGas_AnchorTubingOD: ActNameGas_AnchorTubingOD,
            ActNameGas_SeparatorHP: ActNameGas_SeparatorHP,
            ActNameGas_ChargePumpHP: ActNameGas_ChargePumpHP,
            ActNameGas_HeadPerStage: ActNameGas_HeadPerStage,
            ActNameGas_SeparationEfficiency: ActNameGas_SeparationEfficiency,
            ActNameGas_PressureGradient: ActNameGas_PressureGradient,
            ActNameGas_TotalFluidVolume: ActNameGas_TotalFluidVolume,
            ActNameGas_FreeGas: ActNameGas_FreeGas,
            ActNameGas_GOR: ActNameGas_GOR,
            ActNameGas_GLR: ActNameGas_GLR,
            ActNameGas_GVF: ActNameGas_GVF,
            ActNameGas_VolumeInjested: ActNameGas_VolumeInjested,
            ActNameGas_LiquidVolumetricRate: ActNameGas_LiquidVolumetricRate,
            ActNameGas_LiquidPhaseDensity: ActNameGas_LiquidPhaseDensity,
            ActNameGas_PressureContribution: ActNameGas_PressureContribution,
            ActNameGas_TotalPressure: ActNameGas_TotalPressure,
            ActNameGas_Rs: ActNameGas_Rs,
            ActNameGas_Bg: ActNameGas_Bg,
            ActNameGas_Bo: ActNameGas_Bo,
            ActNameGas_GasVolume: ActNameGas_GasVolume,
            ActNameGas_OilVolume: ActNameGas_OilVolume,
            ActNameGas_WaterVolume: ActNameGas_WaterVolume,
            ActNamebasic_Flop: ActNamebasic_Flop,
            ActNameMotor_T1OperatingTemp: ActNameMotor_T1OperatingTemp,
            GasCompressblty: GasCompressblty,
            FinTemp: FinTemp,
            GasIntakeNaturalSeparatorEfficiency: IntakeNaturalSeparatorEff,
            ChargePumpShowAll: ChargePump_ShowAll,
            Hdn_GKX_ShaftType: Hdn_GKX_ShaftType,
            Hdn_ChargePump1_ShaftType: Hdn_ChargePump1_ShaftType,
            Hdn_ChargePump2_ShaftType: Hdn_ChargePump2_ShaftType,
            Hdn_ChargePump3_ShaftType: Hdn_ChargePump3_ShaftType,
          },
          BasicTDHCalculation: {
            TDHOverride: TDHOverride,
            TubingHead: TubingHead,
            FrictionLoss: FrictionLoss,
            ProductionLevel: ProductionLevel,
            TDH: TDH,
            PIP: PIP,
            PIPNew: PIPNew,
            DesrdPIP: DesrdPIP,
            NewTDH: NewTDH,
            UnitTDHOverrideListVal: UnitTDHOverrideListVal,
            UnitTDHOverrideList: UnitTDHOverrideList,
            UnitTubingHeadListVal: UnitTubingHeadListVal,
            UnitFrictionLossListVal: UnitProductionLevelListVal,
            UnitProductionLevelListVal: UnitTDHListVal,
            UnitTDHListVal: UnitFrictionLossListVal,
            UnitPIPListVal: UnitPIPListVal,
            ActNameBasic_TubingHead: ActNameBasic_TubingHead,
            ActNameBasic_TDH: ActNameBasic_TDH,
            ActNameBasic_FrictionLoss: ActNameBasic_FrictionLoss,
            ActNameBasic_ProductionLevel: ActNameBasic_ProductionLevel,
            ActNameBasic_PIP: ActNameBasic_PIP,
            ActNamebasic_Flop: ActNamebasic_Flop,
            ActNameGas_TotalPressure: ActNameGas_TotalPressure,
          },
          BasicWellIPRCalculation: {
            DepletionPressure: depletionPressure,
            FutureProductionRate: futureProductionRate,
            ShowDepletionPlotInMainReport: showDepletionPlotInMainReport,
            ShowIPRPlotInMainReport: showIPRPlotInMainReport,
          },
        };

        let collection: any = {
          Lifttype: 1,
          Tab1Input: tab1Input,
          Tab2Input: tab2Input,
          Tab3Input: tab3Input,
          Tab4Input: tab4Input,
          Tab5Input: tab5Input,
          BasicWellInflowCalculation: {
            CalMethod: CalMethod,
            CalMethodList: CalMethodList,
            ReservoirHead: ReservoirHead,
            IntakeHead: IntakeHead,
            MaxFlowRate: MaxFlowRate,
            AdditionalBPD: AdditionalBPD,
            UnitReservoirHeadListVal: UnitReservoirHeadListVal,
            UnitIntakeHeadListVal: UnitIntakeHeadListVal,
            UnitMaxFlowRateListVal: UnitMaxFlowRateListVal,
            UnitAdditionalBPDListVal: UnitAdditionalBPDListVal,
            ActNameBasic_ReservoirHead: ActNameBasic_ReservoirHead,
            ActNameBasic_IntakeHead: ActNameBasic_IntakeHead,
          },
          BasicGasCalculation: {
            GasDesign: GasDesign,
            GasDesignList: GasDesignList,
            AnchorOD: AnchorOD,
            AnchorODList: AnchorODList,
            AnchorID: AnchorID,
            TubingOD: AnchorTubingOD,
            AnchorTubingODList: AnchorTubingODList,
            NaturalEfficiency: NaturalEfficiency,
            SeparatorEfficiency: SeparatorEfficiency,
            Rs: Rs,
            Bg: Bg,
            Bo: Bo,
            OilVolume: OilVolume,
            WaterVolume: WaterVolume,
            TotalFluidVolume: TotalFluidVolume,
            GOR: GOR,
            NaturalEfficiencyAnchor: NaturalEfficiencyAnchor,
            GasVolIngested: GasVolIngested,
            LiqVolmRate: LiqVolmRate,
            TotalFluidVolumeHand: TotalFluidVolumeHand,
            FreeGasPercentge: FreeGasPercentge,
            GVFPreSep: GVFPreSep,
            GORPreSep: GORPreSep,
            GLRPreSep: GLRPreSep,
            PrePressGrad: PrePressGrad,
            LiqdPhaseDensity: LiqdPhaseDensity,
            TotalPIP: TotalPIP,
            CombinedSpGr: CombinedSpGr,
            FLOP: FLOP,
            ChargePumpGKX: ChargePumpGKX,
            ChargePumpGKXList: ChargePumpGKXList,
            ChargePump: ChargePump,
            ChargePumpList: ChargePumpList,
            ChargePump2: ChargePump2,
            ChargePumpList2: ChargePumpList2,
            ChargePump3: ChargePump3,
            ChargePumpList3: ChargePumpList3,
            SepSelcted: SepSelcted,
            SeparatorList: SeparatorList,
            NoOfGasSeps: NoOfGasSeps,
            UseOfChgPmp: UseOfChgPmp,
            UseOfChgPmpNew: UseOfChgPmpNew,
            NoOfStages: NoOfStages,
            ChargePumpHdPrStage: ChargePumpHdPrStage,
            ChargePumpDesrdStge: ChargePumpDesrdStge,
            ChargePumpDesrdStge2: ChargePumpDesrdStge2,
            ChargePumpDesrdStge3: ChargePumpDesrdStge3,
            PreAnchorNaturalEfficiency: PreAnchorNaturalEfficiency,
            PreAnchorGOR: PreAnchorGOR,
            PreAnchorGLR: PreAnchorGLR,
            PreAnchorGVF: PreAnchorGVF,
            PreAnchorFreeGas: PreAnchorFreeGas,
            PreAnchorTFV: PreAnchorTFV,
            ChrgePmpGasVolume: ChrgePmpGasVolume,
            ChargePmpSepTFV: ChargePmpSepTFV,
            ChargePmpSepFreeGas: ChargePmpSepFreeGas,
            ChargePmpSepGVF: ChargePmpSepGVF,
            ChargePmpSepGOR: ChargePmpSepGOR,
            ChargePmpPSI: ChargePmpPSI,
            ChargePmpTotalPressure: ChargePmpTotalPressure,
            ChargePumpGLR: ChargePumpGLR,
            ChargePumpPresGrad: ChargePumpPresGrad,
            UnitAdditionalBPDListVal: UnitAdditionalBPDListVal,
            UnitAnchorIDListVal: UnitAnchorIDListVal,
            UnitPressGrdnt: UnitPressGrdnt,
            UnitLiqPhseDens: UnitLiqPhseDens,
            ActNameGas_AnchorOD: ActNameGas_AnchorOD,
            ActNameGas_AnchorID: ActNameGas_AnchorID,
            ActNameGas_AnchorTubingOD: ActNameGas_AnchorTubingOD,
            ActNameGas_SeparatorHP: ActNameGas_SeparatorHP,
            ActNameGas_ChargePumpHP: ActNameGas_ChargePumpHP,
            ActNameGas_HeadPerStage: ActNameGas_HeadPerStage,
            ActNameGas_SeparationEfficiency: ActNameGas_SeparationEfficiency,
            ActNameGas_PressureGradient: ActNameGas_PressureGradient,
            ActNameGas_TotalFluidVolume: ActNameGas_TotalFluidVolume,
            ActNameGas_FreeGas: ActNameGas_FreeGas,
            ActNameGas_GOR: ActNameGas_GOR,
            ActNameGas_GLR: ActNameGas_GLR,
            ActNameGas_GVF: ActNameGas_GVF,
            ActNameGas_VolumeInjested: ActNameGas_VolumeInjested,
            ActNameGas_LiquidVolumetricRate: ActNameGas_LiquidVolumetricRate,
            ActNameGas_LiquidPhaseDensity: ActNameGas_LiquidPhaseDensity,
            ActNameGas_PressureContribution: ActNameGas_PressureContribution,
            ActNameGas_TotalPressure: ActNameGas_TotalPressure,
            ActNameGas_Rs: ActNameGas_Rs,
            ActNameGas_Bg: ActNameGas_Bg,
            ActNameGas_Bo: ActNameGas_Bo,
            ActNameGas_GasVolume: ActNameGas_GasVolume,
            ActNameGas_OilVolume: ActNameGas_OilVolume,
            ActNameGas_WaterVolume: ActNameGas_WaterVolume,
            ActNamebasic_Flop: ActNamebasic_Flop,
            ActNameMotor_T1OperatingTemp: ActNameMotor_T1OperatingTemp,
            GasCompressblty: GasCompressblty,
            FinTemp: FinTemp,
          },
          BasicTDHCalculation: {
            TDHOverride: TDHOverride,
            TubingHead: TubingHead,
            FrictionLoss: FrictionLoss,
            ProductionLevel: ProductionLevel,
            TDH: TDH,
            PIP: PIP,
            PIPNew: PIPNew,
            DesrdPIP: DesrdPIP,
            NewTDH: NewTDH,
            UnitTDHOverrideListVal: UnitTDHOverrideListVal,
            UnitTDHOverrideList: UnitTDHOverrideList,
            UnitTubingHeadListVal: UnitTubingHeadListVal,
            UnitFrictionLossListVal: UnitProductionLevelListVal,
            UnitProductionLevelListVal: UnitTDHListVal,
            UnitTDHListVal: UnitFrictionLossListVal,
            UnitPIPListVal: UnitPIPListVal,
            ActNameBasic_TubingHead: ActNameBasic_TubingHead,
            ActNameBasic_TDH: ActNameBasic_TDH,
            ActNameBasic_FrictionLoss: ActNameBasic_FrictionLoss,
            ActNameBasic_ProductionLevel: ActNameBasic_ProductionLevel,
            ActNameBasic_PIP: ActNameBasic_PIP,
            ActNamebasic_Flop: ActNamebasic_Flop,
            ActNameGas_TotalPressure: ActNameGas_TotalPressure,
          },
          ProjectData: {
            ProjectName: ProjectDetails?.projectName ?? "",
            CaseName: ProjectDetails?.caseName ?? "",
            CaseDescription: ProjectDetails?.caseDescription ?? "",
            UOM: ProjectDetails?.unitMeasurement ?? "",
            DALRep: ProjectDetails?.accountManager ?? "",
            CompanyName: ProjectDetails?.customer ?? "",
            OperatorContact: ProjectDetails?.contact ?? "",
            WellName: ProjectDetails?.well ?? "",
            WellAPI: ProjectDetails?.wellApiNo ?? "",
            Country: ProjectDetails?.country ?? "",
            State: ProjectDetails?.state ?? "",
            Formation: ProjectDetails?.formation ?? "",
            County: ProjectDetails?.county ?? "",
            CountyOther: ProjectDetails?.countyOther ?? "",
            WellCnxId: [0, null]?.includes(ProjectDetails?.wellID) ? null : ProjectDetails?.wellID,
            CustomerCnxId: [0, null]?.includes(ProjectDetails?.customerID) ? null : ProjectDetails?.customerID,
            ComparisonCaseId1: caseComparison?.compareInput1,
            ComparisonCaseId2: caseComparison?.compareInput2,
            ComparisonCaseId3: caseComparison?.compareInput3,
            DisplayCaseName: projectAndAffiliations?.filter((item: any) => item?.projectID === tab1Input?.projectIDNew)?.[0]?.displayCaseName ?? "Case #1",
          },
        };

        let surveyData: WellSurveyServerData[] = [];
        if (wellSurveyData?.length) {
          surveyData = wellSurveyData.map(
            (s: { md: any; inc: any; dls: any }) => {
              return {
                MD: s.md,
                INC: s.inc,
                DLS: s.dls,
              };
            }
          );
        } ///////////////verify output data

        if (
          ProjectDetails?.projectName == "" ||
          ProjectDetails?.projectName == undefined
        ) {
          // this.notifyService.showError("Please enter Project Name.");
          return of(CalculationActions.emptyaction());
        }
        if (templateID === "" || templateID === undefined) {
          NameSearch.Tab1Input.opType = "Update";
        } else {
          NameSearch.Tab1Input.opType = "Add";
        }

        var postData: saveProjectPayload = {
          Lifttype: collection?.Lifttype,
          ESPInputViewModel: NameSearch,
          ESPCalculation: SeatSearch,
          FormCollection: collection,
          basicCalculation: SeatSearch.BasicGasCalculation,
          basicTDHCalculation: SeatSearch.BasicTDHCalculation,
          PumpModel: NameSearch.PumpInput,
          MotorInputModel: NameSearch.MotorInput,
          SurveyData: surveyData.length ? surveyData : null,
          WellSurveyESPAssembly: NameSearch.WellSurveyESPAssembly,
          region: region,
          ProjectData: collection.ProjectData,
          ComparisonCaseId1: caseComparison?.compareInput1,
          ComparisonCaseId2: caseComparison?.compareInput2,
          ComparisonCaseId3: caseComparison?.compareInput3,
          AIEnabled: aiEnabled
        };

        return from(calculationservice.saveProject(postData)).pipe(
          mergeMap((data) => {
            if (data !== undefined && data?.value !== undefined) {
              if (window.location.pathname.includes("templateID")) {
                return [
                  CalculationActions.saveSchematicData(),
                  CalculationActions.saveMainReportDataLake(),
                ];
              } else {
                toast.success("Project saved successfully", {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  style: {
                    background: "#4CAF50",
                    color: "#fff",
                  },
                });

                setTimeout(() => {
                  if (window.location.pathname.includes("caseID")) {
                    window.location.href = `/project-details/projectID=${DefaultProjectID}/caseID=${data?.value}`;
                  } else
                    window.location.href = `/project-details/projectID=${data?.value}`;
                }, 4000);
              }
            }
            return [CalculationActions.emptyaction()];
          }),
          catchError((error) => {
            toast.error("There was an error while saving project.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              style: {
                background: "#4CAF50",
                color: "#fff",
              },
            });
            return of(console.error('There was an error while saving project.', error));
          })
        );
      }
    )
  );
};

const saveSchematicsData = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("calculations/saveSchematicData"),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state?.auth?.user)),
      state$.pipe(
        map((state: RootState) => state?.calculations?.schematicData)
      ),
      state$.pipe(map((state: RootState) => state?.tubing?.tab1Input))
    ),
    switchMap(([actionData, user, schematicsData, tab1Input]) => {
      let schematicData: SchematicsModel = {
        equipmentsList: [],
        miscellaneous: {},
        projectId: "",
        totalEspLength: 0,
        espTailPipeDescender: 0,
        mleLength: 0,
        downholeEquipmentWeight: 0,
        unitSystem: 0,
      };

      let projId: string = tab1Input?.projectIDNew; ///////get projectid from store

      if (schematicsData == null || schematicsData == undefined) {
        if (window.location.pathname.includes("templateID")) {
          toast.success("Project saved successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            style: {
              background: "#4CAF50",
              color: "#fff",
            },
          });
          setTimeout(() => {
            window.location.href = `/project-details/projectID=${projId}`;
          }, 6000);
        }
        return of(CalculationActions.emptyaction());
      }

      schematicData.equipmentsList = schematicsData?.equipmentsList ?? [];
      schematicData.miscellaneous = schematicsData?.miscellaneous;
      schematicData.projectId = projId;
      const updatedMiscList =
        schematicData?.miscellaneous?.miscList?.map((item: any) => ({
          ...item,
          quantity: item?.quantity === "" ? 0 : item?.quantity,
        })) ?? schematicData?.miscellaneous?.miscList;

      let updatedSchematicData = {
        ...schematicData,
        equipmentsList: (schematicData?.equipmentsList || []).map((equipment: any) => ({
          ...equipment,
          projectId: projId,
        })),
        miscellaneous: {
          ...schematicData?.miscellaneous,
          miscList: updatedMiscList,
          createdBy: parseInt(user.userID),
          projectId: projId,
        },
        projectId: projId,
      };

      return from(
        calculationservice.postSchematicsData(updatedSchematicData)
      ).pipe(
        map((data) => {
          if (window.location.pathname.includes("templateID")) {
            toast.success("Project saved successfully", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              style: {
                background: "#4CAF50",
                color: "#fff",
              },
            });
            setTimeout(() => {
              window.location.href = `/project-details/projectID=${projId}`;
            }, 6000);
          }
          return CalculationActions.emptyaction();
        }),
        catchError((error) => {
          return of(console.error("There was an error while saving project."));
        })
      );
    })
  );
};

const saveDataLakeMainReport = (action$: any, state$: any) => {
  return action$.pipe(
    ofType(
      "calculations/saveMainReportDataLake"
    ),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state)),
      state$.pipe(map((state: RootState) => state?.createProject)),
    ),
    switchMap(
      ([
        actionData,
        sateData,
        projectTabData
      ]) => {

        let mainReportData = getMainReportDataFromUtility(sateData);
        mainReportData.inputs.ProjectName = projectTabData?.projectName ?? '';
        mainReportData.inputs.AccountManager = projectTabData?.accountManager ?? '';
        mainReportData.inputs.CustomerRep = projectTabData?.contact ?? '';
        mainReportData.inputs.CustomerName = projectTabData?.customer ?? '';
        mainReportData.inputs.WellName = projectTabData?.well ?? '';
        mainReportData.inputs.WellApiNumber = projectTabData?.wellApiNo ?? '';
        mainReportData.inputs.FormationValue = projectTabData?.formation ?? '';
        mainReportData.inputs.CaseName = projectTabData?.caseName ?? '';

        return from(
          calculationservice.SaveMainReportData(mainReportData?.inputs, mainReportData?.projectId, mainReportData?.unitSystem)
        ).pipe(
          map((data) => {
            return CalculationActions.emptyaction();
          }),
          catchError((error) => {
            return of(console.error('There was an error while saving main report details to Data Lake.'));
          })
        );
      }
    )
  );
};

const getComparisonData = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("Comparison/getComparisonData"),
    withLatestFrom(state$.pipe(map((state: RootState) => state?.comparison))),
    switchMap(([actionData, sateData]) => {
      return from(
        calculationservice.GetCaseComparisonData(
          sateData?.compareInput1,
          sateData?.compareInput2,
          sateData?.compareInput3
        )
      ).pipe(
        mergeMap((data) => {
          let case1Data = data?.caseComparisions?.filter(
            (item: any) => item?.caseId === sateData?.compareInput1
          );
          let case2Data = data?.caseComparisions?.filter(
            (item: any) => item?.caseId === sateData?.compareInput2
          );
          let case3Data = data?.caseComparisions?.filter(
            (item: any) => item?.caseId === sateData?.compareInput3
          );
          return [
            setComparisonData1(case1Data?.[0] ?? {}),
            setComparisonData2(case2Data?.[0] ?? {}),
            setComparisonData3(case3Data?.[0] ?? {}),
          ];
        }),
        catchError((error) => {
          return of(
            console.error("There was an error while fetching comparison data.")
          );
        })
      );
    })
  );
};

interface CalculationsAction {
  type: string;
  payload: any;
};

export interface DropDownObjectValueModel {
  [key: string]: Separator;
};

interface Separator {
  id: string;
  series: string;
  seriesType: string;
};

const getCalculationsEpic = (action$: any) =>
  action$.pipe(
    ofType("calculations/getCalculations"),
    mergeMap((action: CalculationsAction) =>
      from(getCalculations(action.payload)).pipe(
        map((result) => ({
          type: "calculations/getCalculationsSuccess",
          payload: result,
        })),
        catchError((error) =>
          of({ type: "calculations/getCalculationsError", payload: error })
        )
      )
    )
  );

const getCase1SystemTDH = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("Comparison/setComparisonData1"),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state?.comparison?.comparisonData1))
    ),
    map(([actionData, caseData]) => {
      if (caseData && Object?.keys(caseData)?.length > 0) {
        const pumpTDH = isNaN(+caseData?.pumpTDH) ? 0 : +caseData?.pumpTDH;
        const gkxTDH = isNaN(+caseData?.gkxFinalTDH) ? 0 : +caseData?.gkxFinalTDH;
        const cp1TDH = isNaN(+caseData?.chargePump1FinalTDH) ? 0 : +caseData?.chargePump1FinalTDH;
        const cp2TDH = isNaN(+caseData?.chargePump2FinalTDH) ? 0 : +caseData?.chargePump2FinalTDH;
        const cp3TDH = isNaN(+caseData?.chargePump3FinalTDH) ? 0 : +caseData?.chargePump3FinalTDH;
        const systemLiftTdh = (pumpTDH + gkxTDH + cp1TDH + cp2TDH + cp3TDH)?.toFixed(2);
        return setCase1SystemTDH(systemLiftTdh);
      }
      return setCase1SystemTDH(null);
    })
  );
};

const getCase2SystemTDH = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("Comparison/setComparisonData2"),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state?.comparison?.comparisonData2))
    ),
    map(([actionData, caseData]) => {
      if (caseData && Object?.keys(caseData)?.length > 0) {
        const pumpTDH = isNaN(+caseData?.pumpTDH) ? 0 : +caseData?.pumpTDH;
        const gkxTDH = isNaN(+caseData?.gkxFinalTDH) ? 0 : +caseData?.gkxFinalTDH;
        const cp1TDH = isNaN(+caseData?.chargePump1FinalTDH) ? 0 : +caseData?.chargePump1FinalTDH;
        const cp2TDH = isNaN(+caseData?.chargePump2FinalTDH) ? 0 : +caseData?.chargePump2FinalTDH;
        const cp3TDH = isNaN(+caseData?.chargePump3FinalTDH) ? 0 : +caseData?.chargePump3FinalTDH;
        const systemLiftTdh = (pumpTDH + gkxTDH + cp1TDH + cp2TDH + cp3TDH)?.toFixed(2);
        return setCase2SystemTDH(systemLiftTdh);
      }
      return setCase2SystemTDH(null);
    })
  );
};

const getCase3SystemTDH = (action$: any, state$: any) => {
  return action$.pipe(
    ofType("Comparison/setComparisonData3"),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state?.comparison?.comparisonData3))
    ),
    map(([actionData, caseData]) => {
      if (caseData && Object?.keys(caseData)?.length > 0) {
        const pumpTDH = isNaN(+caseData?.pumpTDH) ? 0 : +caseData?.pumpTDH;
        const gkxTDH = isNaN(+caseData?.gkxFinalTDH) ? 0 : +caseData?.gkxFinalTDH;
        const cp1TDH = isNaN(+caseData?.chargePump1FinalTDH) ? 0 : +caseData?.chargePump1FinalTDH;
        const cp2TDH = isNaN(+caseData?.chargePump2FinalTDH) ? 0 : +caseData?.chargePump2FinalTDH;
        const cp3TDH = isNaN(+caseData?.chargePump3FinalTDH) ? 0 : +caseData?.chargePump3FinalTDH;
        const systemLiftTdh = (pumpTDH + gkxTDH + cp1TDH + cp2TDH + cp3TDH)?.toFixed(2);
        return setCase3SystemTDH(systemLiftTdh);
      }
      return setCase3SystemTDH(null);
    })
  );
};

const setIntakeMD = (action$: any, state$: any) => {
  return action$.pipe(
    ofType(
      "gasCalculation/setExistedGasSepEquipments",
      "gasCalculation/setExistedGasHandlerEquipments",
      "gasCalculation/setExistedSRGasPump1Equipments",
      "gasCalculation/setExistedSRGasPump2Equipments",
      "gasCalculation/setExistedSRGasPump3Equipments",
      "well/setSettingDepth",
    ),
    withLatestFrom(
      state$.pipe(map((state: RootState) => state?.wellInput?.tab2Input)),
      state$.pipe(map((state: RootState) => state?.gasCalculations?.existedGasSepEquipments)),
      state$.pipe(map((state: RootState) => state?.gasCalculations?.existedGasHandlerEquipments)),
      state$.pipe(map((state: RootState) => state?.gasCalculations?.existedSRGasPump1Equipments)),
      state$.pipe(map((state: RootState) => state?.gasCalculations?.existedSRGasPump2Equipments)),
      state$.pipe(map((state: RootState) => state?.gasCalculations?.existedSRGasPump3Equipments)),
      state$.pipe(map((state: RootState) => state?.pump?.ESPEquipments)),
    ),
    map(([actionData, tab2Input, existedGasSepEquipments, existedGasHandlerEquipments, existedSRGasPump1Equipments, existedSRGasPump2Equipments, existedSRGasPump3Equipments, ESPEquipments]) => {
      const gasSepFilter = existedGasSepEquipments?.filter((item: any) => Object?.keys(item).length > 0);
      const gasHandlerFilter = existedGasHandlerEquipments?.filter((item: any) => Object?.keys(item).length > 0);
      const chargePump1Filter = existedSRGasPump1Equipments?.filter((item: any) => Object?.keys(item).length > 0);
      const chargePump2Filter = existedSRGasPump2Equipments?.filter((item: any) => Object?.keys(item).length > 0);
      const chargePump3Filter = existedSRGasPump3Equipments?.filter((item: any) => Object?.keys(item).length > 0);
      const mainPumpFilter = ESPEquipments?.filter((item: any) => Object?.keys(item).length > 0);
      if (
        gasSepFilter?.length > 0
      ) {
        return CalculationActions.setIntakeMD(gasSepFilter[gasSepFilter?.length - 1]?.setDepth);
      } else if (gasSepFilter?.length === 0 && gasHandlerFilter) {
        if (
          gasHandlerFilter?.length > 0
        ) {
          return CalculationActions.setIntakeMD(gasHandlerFilter[gasHandlerFilter?.length - 1]?.setDepth);
        } else if (gasHandlerFilter?.length === 0 && chargePump1Filter) {
          if (
            chargePump1Filter?.length > 0
          ) {
            return CalculationActions.setIntakeMD(chargePump1Filter[chargePump1Filter?.length - 1]?.setDepth);
          } else if (chargePump1Filter?.length === 0 && chargePump2Filter) {
            if (
              chargePump2Filter?.length > 0
            ) {
              return CalculationActions.setIntakeMD(chargePump2Filter[chargePump2Filter?.length - 1]?.setDepth);
            } else if (chargePump2Filter?.length === 0 && chargePump3Filter) {
              if (
                chargePump3Filter?.length > 0
              ) {
                return CalculationActions.setIntakeMD(chargePump3Filter[chargePump3Filter?.length - 1]?.setDepth);
              } else if (chargePump3Filter?.length === 0 && mainPumpFilter) {
                if (
                  mainPumpFilter?.length > 0
                ) {
                  return CalculationActions.setIntakeMD(mainPumpFilter[mainPumpFilter?.length - 1]?.setDepth);
                }
              }
            }
          }
        }
      }
      return CalculationActions.setIntakeMD(tab2Input?.pumpSetting);
    })
  );
};

export const calculationEpic = combineEpics(
  fetchProjectDetailsEpic,
  calculationsTemplate,
  fetchOnCalculate,
  convertSchematicsDataToEquipment,
  fetchSchematicData,
  fetchCalculatedSetDepth,
  calculateSurfaceVoltage,
  SetSchematicEquipmentData,
  fetchMotorLoadFrequency,
  getCalculationsEpic,
  saveProject,
  saveSchematicsData,
  saveDataLakeMainReport,
  getComparisonData,
  getCase1SystemTDH,
  getCase2SystemTDH,
  getCase3SystemTDH,
  setIntakeMD,
);
